import * as i0 from '@angular/core';
import { Component, SkipSelf, Host, Input, NgModule, Inject, ContentChildren, forwardRef, Output } from '@angular/core';
import * as i1 from 'devextreme-angular/core';
import { CollectionNestedOption, NestedOptionHost, NestedOption, extractTemplate, DxTemplateHost } from 'devextreme-angular/core';
import { DOCUMENT } from '@angular/common';

/*!
 * devextreme-angular
 * Version: 24.2.3
 * Build date: Fri Dec 06 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
const _c0 = ["*"];
class DxiFormAsyncRuleComponent extends CollectionNestedOption {
  get ignoreEmptyValue() {
    return this._getOption('ignoreEmptyValue');
  }
  set ignoreEmptyValue(value) {
    this._setOption('ignoreEmptyValue', value);
  }
  get message() {
    return this._getOption('message');
  }
  set message(value) {
    this._setOption('message', value);
  }
  get reevaluate() {
    return this._getOption('reevaluate');
  }
  set reevaluate(value) {
    this._setOption('reevaluate', value);
  }
  get type() {
    return this._getOption('type');
  }
  set type(value) {
    this._setOption('type', value);
  }
  get validationCallback() {
    return this._getOption('validationCallback');
  }
  set validationCallback(value) {
    this._setOption('validationCallback', value);
  }
  get _optionPath() {
    return 'validationRules';
  }
  constructor(parentOptionHost, optionHost) {
    super();
    parentOptionHost.setNestedOption(this);
    optionHost.setHost(this, this._fullOptionPath.bind(this));
  }
  ngOnDestroy() {
    this._deleteRemovedOptions(this._fullOptionPath());
  }
  /** @nocollapse */
  static ɵfac = function DxiFormAsyncRuleComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DxiFormAsyncRuleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
  };
  /** @nocollapse */
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DxiFormAsyncRuleComponent,
    selectors: [["dxi-form-async-rule"]],
    inputs: {
      ignoreEmptyValue: "ignoreEmptyValue",
      message: "message",
      reevaluate: "reevaluate",
      type: "type",
      validationCallback: "validationCallback"
    },
    standalone: false,
    features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
    decls: 0,
    vars: 0,
    template: function DxiFormAsyncRuleComponent_Template(rf, ctx) {},
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DxiFormAsyncRuleComponent, [{
    type: Component,
    args: [{
      selector: 'dxi-form-async-rule',
      template: '',
      providers: [NestedOptionHost]
    }]
  }], () => [{
    type: i1.NestedOptionHost,
    decorators: [{
      type: SkipSelf
    }, {
      type: Host
    }]
  }, {
    type: i1.NestedOptionHost,
    decorators: [{
      type: Host
    }]
  }], {
    ignoreEmptyValue: [{
      type: Input
    }],
    message: [{
      type: Input
    }],
    reevaluate: [{
      type: Input
    }],
    type: [{
      type: Input
    }],
    validationCallback: [{
      type: Input
    }]
  });
})();
class DxiFormAsyncRuleModule {
  /** @nocollapse */static ɵfac = function DxiFormAsyncRuleModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DxiFormAsyncRuleModule)();
  };
  /** @nocollapse */
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: DxiFormAsyncRuleModule
  });
  /** @nocollapse */
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DxiFormAsyncRuleModule, [{
    type: NgModule,
    args: [{
      declarations: [DxiFormAsyncRuleComponent],
      exports: [DxiFormAsyncRuleComponent]
    }]
  }], null, null);
})();

/*!
 * devextreme-angular
 * Version: 24.2.3
 * Build date: Fri Dec 06 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
class DxiFormButtonItemComponent extends CollectionNestedOption {
  get buttonOptions() {
    return this._getOption('buttonOptions');
  }
  set buttonOptions(value) {
    this._setOption('buttonOptions', value);
  }
  get colSpan() {
    return this._getOption('colSpan');
  }
  set colSpan(value) {
    this._setOption('colSpan', value);
  }
  get cssClass() {
    return this._getOption('cssClass');
  }
  set cssClass(value) {
    this._setOption('cssClass', value);
  }
  get horizontalAlignment() {
    return this._getOption('horizontalAlignment');
  }
  set horizontalAlignment(value) {
    this._setOption('horizontalAlignment', value);
  }
  get itemType() {
    return this._getOption('itemType');
  }
  set itemType(value) {
    this._setOption('itemType', value);
  }
  get name() {
    return this._getOption('name');
  }
  set name(value) {
    this._setOption('name', value);
  }
  get verticalAlignment() {
    return this._getOption('verticalAlignment');
  }
  set verticalAlignment(value) {
    this._setOption('verticalAlignment', value);
  }
  get visible() {
    return this._getOption('visible');
  }
  set visible(value) {
    this._setOption('visible', value);
  }
  get visibleIndex() {
    return this._getOption('visibleIndex');
  }
  set visibleIndex(value) {
    this._setOption('visibleIndex', value);
  }
  get _optionPath() {
    return 'items';
  }
  constructor(parentOptionHost, optionHost) {
    super();
    parentOptionHost.setNestedOption(this);
    optionHost.setHost(this, this._fullOptionPath.bind(this));
  }
  ngOnDestroy() {
    this._deleteRemovedOptions(this._fullOptionPath());
  }
  /** @nocollapse */
  static ɵfac = function DxiFormButtonItemComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DxiFormButtonItemComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
  };
  /** @nocollapse */
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DxiFormButtonItemComponent,
    selectors: [["dxi-form-button-item"]],
    inputs: {
      buttonOptions: "buttonOptions",
      colSpan: "colSpan",
      cssClass: "cssClass",
      horizontalAlignment: "horizontalAlignment",
      itemType: "itemType",
      name: "name",
      verticalAlignment: "verticalAlignment",
      visible: "visible",
      visibleIndex: "visibleIndex"
    },
    standalone: false,
    features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
    decls: 0,
    vars: 0,
    template: function DxiFormButtonItemComponent_Template(rf, ctx) {},
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DxiFormButtonItemComponent, [{
    type: Component,
    args: [{
      selector: 'dxi-form-button-item',
      template: '',
      providers: [NestedOptionHost]
    }]
  }], () => [{
    type: i1.NestedOptionHost,
    decorators: [{
      type: SkipSelf
    }, {
      type: Host
    }]
  }, {
    type: i1.NestedOptionHost,
    decorators: [{
      type: Host
    }]
  }], {
    buttonOptions: [{
      type: Input
    }],
    colSpan: [{
      type: Input
    }],
    cssClass: [{
      type: Input
    }],
    horizontalAlignment: [{
      type: Input
    }],
    itemType: [{
      type: Input
    }],
    name: [{
      type: Input
    }],
    verticalAlignment: [{
      type: Input
    }],
    visible: [{
      type: Input
    }],
    visibleIndex: [{
      type: Input
    }]
  });
})();
class DxiFormButtonItemModule {
  /** @nocollapse */static ɵfac = function DxiFormButtonItemModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DxiFormButtonItemModule)();
  };
  /** @nocollapse */
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: DxiFormButtonItemModule
  });
  /** @nocollapse */
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DxiFormButtonItemModule, [{
    type: NgModule,
    args: [{
      declarations: [DxiFormButtonItemComponent],
      exports: [DxiFormButtonItemComponent]
    }]
  }], null, null);
})();

/*!
 * devextreme-angular
 * Version: 24.2.3
 * Build date: Fri Dec 06 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
class DxoFormButtonOptionsComponent extends NestedOption {
  renderer;
  document;
  element;
  get accessKey() {
    return this._getOption('accessKey');
  }
  set accessKey(value) {
    this._setOption('accessKey', value);
  }
  get activeStateEnabled() {
    return this._getOption('activeStateEnabled');
  }
  set activeStateEnabled(value) {
    this._setOption('activeStateEnabled', value);
  }
  get disabled() {
    return this._getOption('disabled');
  }
  set disabled(value) {
    this._setOption('disabled', value);
  }
  get elementAttr() {
    return this._getOption('elementAttr');
  }
  set elementAttr(value) {
    this._setOption('elementAttr', value);
  }
  get focusStateEnabled() {
    return this._getOption('focusStateEnabled');
  }
  set focusStateEnabled(value) {
    this._setOption('focusStateEnabled', value);
  }
  get height() {
    return this._getOption('height');
  }
  set height(value) {
    this._setOption('height', value);
  }
  get hint() {
    return this._getOption('hint');
  }
  set hint(value) {
    this._setOption('hint', value);
  }
  get hoverStateEnabled() {
    return this._getOption('hoverStateEnabled');
  }
  set hoverStateEnabled(value) {
    this._setOption('hoverStateEnabled', value);
  }
  get icon() {
    return this._getOption('icon');
  }
  set icon(value) {
    this._setOption('icon', value);
  }
  get onClick() {
    return this._getOption('onClick');
  }
  set onClick(value) {
    this._setOption('onClick', value);
  }
  get onContentReady() {
    return this._getOption('onContentReady');
  }
  set onContentReady(value) {
    this._setOption('onContentReady', value);
  }
  get onDisposing() {
    return this._getOption('onDisposing');
  }
  set onDisposing(value) {
    this._setOption('onDisposing', value);
  }
  get onInitialized() {
    return this._getOption('onInitialized');
  }
  set onInitialized(value) {
    this._setOption('onInitialized', value);
  }
  get onOptionChanged() {
    return this._getOption('onOptionChanged');
  }
  set onOptionChanged(value) {
    this._setOption('onOptionChanged', value);
  }
  get rtlEnabled() {
    return this._getOption('rtlEnabled');
  }
  set rtlEnabled(value) {
    this._setOption('rtlEnabled', value);
  }
  get stylingMode() {
    return this._getOption('stylingMode');
  }
  set stylingMode(value) {
    this._setOption('stylingMode', value);
  }
  get tabIndex() {
    return this._getOption('tabIndex');
  }
  set tabIndex(value) {
    this._setOption('tabIndex', value);
  }
  get template() {
    return this._getOption('template');
  }
  set template(value) {
    this._setOption('template', value);
  }
  get text() {
    return this._getOption('text');
  }
  set text(value) {
    this._setOption('text', value);
  }
  get type() {
    return this._getOption('type');
  }
  set type(value) {
    this._setOption('type', value);
  }
  get useSubmitBehavior() {
    return this._getOption('useSubmitBehavior');
  }
  set useSubmitBehavior(value) {
    this._setOption('useSubmitBehavior', value);
  }
  get validationGroup() {
    return this._getOption('validationGroup');
  }
  set validationGroup(value) {
    this._setOption('validationGroup', value);
  }
  get visible() {
    return this._getOption('visible');
  }
  set visible(value) {
    this._setOption('visible', value);
  }
  get width() {
    return this._getOption('width');
  }
  set width(value) {
    this._setOption('width', value);
  }
  get _optionPath() {
    return 'buttonOptions';
  }
  constructor(parentOptionHost, optionHost, renderer, document, templateHost, element) {
    super();
    this.renderer = renderer;
    this.document = document;
    this.element = element;
    parentOptionHost.setNestedOption(this);
    optionHost.setHost(this, this._fullOptionPath.bind(this));
    templateHost.setHost(this);
  }
  setTemplate(template) {
    this.template = template;
  }
  ngAfterViewInit() {
    extractTemplate(this, this.element, this.renderer, this.document);
  }
  ngOnInit() {
    this._addRecreatedComponent();
  }
  ngOnDestroy() {
    this._addRemovedOption(this._getOptionPath());
  }
  /** @nocollapse */
  static ɵfac = function DxoFormButtonOptionsComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DxoFormButtonOptionsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i1.DxTemplateHost, 1), i0.ɵɵdirectiveInject(i0.ElementRef));
  };
  /** @nocollapse */
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DxoFormButtonOptionsComponent,
    selectors: [["dxo-form-button-options"]],
    inputs: {
      accessKey: "accessKey",
      activeStateEnabled: "activeStateEnabled",
      disabled: "disabled",
      elementAttr: "elementAttr",
      focusStateEnabled: "focusStateEnabled",
      height: "height",
      hint: "hint",
      hoverStateEnabled: "hoverStateEnabled",
      icon: "icon",
      onClick: "onClick",
      onContentReady: "onContentReady",
      onDisposing: "onDisposing",
      onInitialized: "onInitialized",
      onOptionChanged: "onOptionChanged",
      rtlEnabled: "rtlEnabled",
      stylingMode: "stylingMode",
      tabIndex: "tabIndex",
      template: "template",
      text: "text",
      type: "type",
      useSubmitBehavior: "useSubmitBehavior",
      validationGroup: "validationGroup",
      visible: "visible",
      width: "width"
    },
    standalone: false,
    features: [i0.ɵɵProvidersFeature([NestedOptionHost, DxTemplateHost]), i0.ɵɵInheritDefinitionFeature],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function DxoFormButtonOptionsComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    styles: ["[_nghost-%COMP%]{display:block}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DxoFormButtonOptionsComponent, [{
    type: Component,
    args: [{
      selector: 'dxo-form-button-options',
      template: '<ng-content></ng-content>',
      providers: [NestedOptionHost, DxTemplateHost],
      styles: [":host{display:block}\n"]
    }]
  }], () => [{
    type: i1.NestedOptionHost,
    decorators: [{
      type: SkipSelf
    }, {
      type: Host
    }]
  }, {
    type: i1.NestedOptionHost,
    decorators: [{
      type: Host
    }]
  }, {
    type: i0.Renderer2
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [DOCUMENT]
    }]
  }, {
    type: i1.DxTemplateHost,
    decorators: [{
      type: Host
    }]
  }, {
    type: i0.ElementRef
  }], {
    accessKey: [{
      type: Input
    }],
    activeStateEnabled: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    elementAttr: [{
      type: Input
    }],
    focusStateEnabled: [{
      type: Input
    }],
    height: [{
      type: Input
    }],
    hint: [{
      type: Input
    }],
    hoverStateEnabled: [{
      type: Input
    }],
    icon: [{
      type: Input
    }],
    onClick: [{
      type: Input
    }],
    onContentReady: [{
      type: Input
    }],
    onDisposing: [{
      type: Input
    }],
    onInitialized: [{
      type: Input
    }],
    onOptionChanged: [{
      type: Input
    }],
    rtlEnabled: [{
      type: Input
    }],
    stylingMode: [{
      type: Input
    }],
    tabIndex: [{
      type: Input
    }],
    template: [{
      type: Input
    }],
    text: [{
      type: Input
    }],
    type: [{
      type: Input
    }],
    useSubmitBehavior: [{
      type: Input
    }],
    validationGroup: [{
      type: Input
    }],
    visible: [{
      type: Input
    }],
    width: [{
      type: Input
    }]
  });
})();
class DxoFormButtonOptionsModule {
  /** @nocollapse */static ɵfac = function DxoFormButtonOptionsModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DxoFormButtonOptionsModule)();
  };
  /** @nocollapse */
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: DxoFormButtonOptionsModule
  });
  /** @nocollapse */
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DxoFormButtonOptionsModule, [{
    type: NgModule,
    args: [{
      declarations: [DxoFormButtonOptionsComponent],
      exports: [DxoFormButtonOptionsComponent]
    }]
  }], null, null);
})();

/*!
 * devextreme-angular
 * Version: 24.2.3
 * Build date: Fri Dec 06 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
class DxoFormColCountByScreenComponent extends NestedOption {
  get lg() {
    return this._getOption('lg');
  }
  set lg(value) {
    this._setOption('lg', value);
  }
  get md() {
    return this._getOption('md');
  }
  set md(value) {
    this._setOption('md', value);
  }
  get sm() {
    return this._getOption('sm');
  }
  set sm(value) {
    this._setOption('sm', value);
  }
  get xs() {
    return this._getOption('xs');
  }
  set xs(value) {
    this._setOption('xs', value);
  }
  get _optionPath() {
    return 'colCountByScreen';
  }
  constructor(parentOptionHost, optionHost) {
    super();
    parentOptionHost.setNestedOption(this);
    optionHost.setHost(this, this._fullOptionPath.bind(this));
  }
  ngOnInit() {
    this._addRecreatedComponent();
  }
  ngOnDestroy() {
    this._addRemovedOption(this._getOptionPath());
  }
  /** @nocollapse */
  static ɵfac = function DxoFormColCountByScreenComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DxoFormColCountByScreenComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
  };
  /** @nocollapse */
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DxoFormColCountByScreenComponent,
    selectors: [["dxo-form-col-count-by-screen"]],
    inputs: {
      lg: "lg",
      md: "md",
      sm: "sm",
      xs: "xs"
    },
    standalone: false,
    features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
    decls: 0,
    vars: 0,
    template: function DxoFormColCountByScreenComponent_Template(rf, ctx) {},
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DxoFormColCountByScreenComponent, [{
    type: Component,
    args: [{
      selector: 'dxo-form-col-count-by-screen',
      template: '',
      providers: [NestedOptionHost]
    }]
  }], () => [{
    type: i1.NestedOptionHost,
    decorators: [{
      type: SkipSelf
    }, {
      type: Host
    }]
  }, {
    type: i1.NestedOptionHost,
    decorators: [{
      type: Host
    }]
  }], {
    lg: [{
      type: Input
    }],
    md: [{
      type: Input
    }],
    sm: [{
      type: Input
    }],
    xs: [{
      type: Input
    }]
  });
})();
class DxoFormColCountByScreenModule {
  /** @nocollapse */static ɵfac = function DxoFormColCountByScreenModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DxoFormColCountByScreenModule)();
  };
  /** @nocollapse */
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: DxoFormColCountByScreenModule
  });
  /** @nocollapse */
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DxoFormColCountByScreenModule, [{
    type: NgModule,
    args: [{
      declarations: [DxoFormColCountByScreenComponent],
      exports: [DxoFormColCountByScreenComponent]
    }]
  }], null, null);
})();

/*!
 * devextreme-angular
 * Version: 24.2.3
 * Build date: Fri Dec 06 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
class DxiFormCompareRuleComponent extends CollectionNestedOption {
  get comparisonTarget() {
    return this._getOption('comparisonTarget');
  }
  set comparisonTarget(value) {
    this._setOption('comparisonTarget', value);
  }
  get comparisonType() {
    return this._getOption('comparisonType');
  }
  set comparisonType(value) {
    this._setOption('comparisonType', value);
  }
  get ignoreEmptyValue() {
    return this._getOption('ignoreEmptyValue');
  }
  set ignoreEmptyValue(value) {
    this._setOption('ignoreEmptyValue', value);
  }
  get message() {
    return this._getOption('message');
  }
  set message(value) {
    this._setOption('message', value);
  }
  get type() {
    return this._getOption('type');
  }
  set type(value) {
    this._setOption('type', value);
  }
  get _optionPath() {
    return 'validationRules';
  }
  constructor(parentOptionHost, optionHost) {
    super();
    parentOptionHost.setNestedOption(this);
    optionHost.setHost(this, this._fullOptionPath.bind(this));
  }
  ngOnDestroy() {
    this._deleteRemovedOptions(this._fullOptionPath());
  }
  /** @nocollapse */
  static ɵfac = function DxiFormCompareRuleComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DxiFormCompareRuleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
  };
  /** @nocollapse */
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DxiFormCompareRuleComponent,
    selectors: [["dxi-form-compare-rule"]],
    inputs: {
      comparisonTarget: "comparisonTarget",
      comparisonType: "comparisonType",
      ignoreEmptyValue: "ignoreEmptyValue",
      message: "message",
      type: "type"
    },
    standalone: false,
    features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
    decls: 0,
    vars: 0,
    template: function DxiFormCompareRuleComponent_Template(rf, ctx) {},
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DxiFormCompareRuleComponent, [{
    type: Component,
    args: [{
      selector: 'dxi-form-compare-rule',
      template: '',
      providers: [NestedOptionHost]
    }]
  }], () => [{
    type: i1.NestedOptionHost,
    decorators: [{
      type: SkipSelf
    }, {
      type: Host
    }]
  }, {
    type: i1.NestedOptionHost,
    decorators: [{
      type: Host
    }]
  }], {
    comparisonTarget: [{
      type: Input
    }],
    comparisonType: [{
      type: Input
    }],
    ignoreEmptyValue: [{
      type: Input
    }],
    message: [{
      type: Input
    }],
    type: [{
      type: Input
    }]
  });
})();
class DxiFormCompareRuleModule {
  /** @nocollapse */static ɵfac = function DxiFormCompareRuleModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DxiFormCompareRuleModule)();
  };
  /** @nocollapse */
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: DxiFormCompareRuleModule
  });
  /** @nocollapse */
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DxiFormCompareRuleModule, [{
    type: NgModule,
    args: [{
      declarations: [DxiFormCompareRuleComponent],
      exports: [DxiFormCompareRuleComponent]
    }]
  }], null, null);
})();

/*!
 * devextreme-angular
 * Version: 24.2.3
 * Build date: Fri Dec 06 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
class DxiFormCustomRuleComponent extends CollectionNestedOption {
  get ignoreEmptyValue() {
    return this._getOption('ignoreEmptyValue');
  }
  set ignoreEmptyValue(value) {
    this._setOption('ignoreEmptyValue', value);
  }
  get message() {
    return this._getOption('message');
  }
  set message(value) {
    this._setOption('message', value);
  }
  get reevaluate() {
    return this._getOption('reevaluate');
  }
  set reevaluate(value) {
    this._setOption('reevaluate', value);
  }
  get type() {
    return this._getOption('type');
  }
  set type(value) {
    this._setOption('type', value);
  }
  get validationCallback() {
    return this._getOption('validationCallback');
  }
  set validationCallback(value) {
    this._setOption('validationCallback', value);
  }
  get _optionPath() {
    return 'validationRules';
  }
  constructor(parentOptionHost, optionHost) {
    super();
    parentOptionHost.setNestedOption(this);
    optionHost.setHost(this, this._fullOptionPath.bind(this));
  }
  ngOnDestroy() {
    this._deleteRemovedOptions(this._fullOptionPath());
  }
  /** @nocollapse */
  static ɵfac = function DxiFormCustomRuleComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DxiFormCustomRuleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
  };
  /** @nocollapse */
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DxiFormCustomRuleComponent,
    selectors: [["dxi-form-custom-rule"]],
    inputs: {
      ignoreEmptyValue: "ignoreEmptyValue",
      message: "message",
      reevaluate: "reevaluate",
      type: "type",
      validationCallback: "validationCallback"
    },
    standalone: false,
    features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
    decls: 0,
    vars: 0,
    template: function DxiFormCustomRuleComponent_Template(rf, ctx) {},
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DxiFormCustomRuleComponent, [{
    type: Component,
    args: [{
      selector: 'dxi-form-custom-rule',
      template: '',
      providers: [NestedOptionHost]
    }]
  }], () => [{
    type: i1.NestedOptionHost,
    decorators: [{
      type: SkipSelf
    }, {
      type: Host
    }]
  }, {
    type: i1.NestedOptionHost,
    decorators: [{
      type: Host
    }]
  }], {
    ignoreEmptyValue: [{
      type: Input
    }],
    message: [{
      type: Input
    }],
    reevaluate: [{
      type: Input
    }],
    type: [{
      type: Input
    }],
    validationCallback: [{
      type: Input
    }]
  });
})();
class DxiFormCustomRuleModule {
  /** @nocollapse */static ɵfac = function DxiFormCustomRuleModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DxiFormCustomRuleModule)();
  };
  /** @nocollapse */
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: DxiFormCustomRuleModule
  });
  /** @nocollapse */
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DxiFormCustomRuleModule, [{
    type: NgModule,
    args: [{
      declarations: [DxiFormCustomRuleComponent],
      exports: [DxiFormCustomRuleComponent]
    }]
  }], null, null);
})();

/*!
 * devextreme-angular
 * Version: 24.2.3
 * Build date: Fri Dec 06 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
class DxiFormEmailRuleComponent extends CollectionNestedOption {
  get ignoreEmptyValue() {
    return this._getOption('ignoreEmptyValue');
  }
  set ignoreEmptyValue(value) {
    this._setOption('ignoreEmptyValue', value);
  }
  get message() {
    return this._getOption('message');
  }
  set message(value) {
    this._setOption('message', value);
  }
  get type() {
    return this._getOption('type');
  }
  set type(value) {
    this._setOption('type', value);
  }
  get _optionPath() {
    return 'validationRules';
  }
  constructor(parentOptionHost, optionHost) {
    super();
    parentOptionHost.setNestedOption(this);
    optionHost.setHost(this, this._fullOptionPath.bind(this));
  }
  ngOnDestroy() {
    this._deleteRemovedOptions(this._fullOptionPath());
  }
  /** @nocollapse */
  static ɵfac = function DxiFormEmailRuleComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DxiFormEmailRuleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
  };
  /** @nocollapse */
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DxiFormEmailRuleComponent,
    selectors: [["dxi-form-email-rule"]],
    inputs: {
      ignoreEmptyValue: "ignoreEmptyValue",
      message: "message",
      type: "type"
    },
    standalone: false,
    features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
    decls: 0,
    vars: 0,
    template: function DxiFormEmailRuleComponent_Template(rf, ctx) {},
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DxiFormEmailRuleComponent, [{
    type: Component,
    args: [{
      selector: 'dxi-form-email-rule',
      template: '',
      providers: [NestedOptionHost]
    }]
  }], () => [{
    type: i1.NestedOptionHost,
    decorators: [{
      type: SkipSelf
    }, {
      type: Host
    }]
  }, {
    type: i1.NestedOptionHost,
    decorators: [{
      type: Host
    }]
  }], {
    ignoreEmptyValue: [{
      type: Input
    }],
    message: [{
      type: Input
    }],
    type: [{
      type: Input
    }]
  });
})();
class DxiFormEmailRuleModule {
  /** @nocollapse */static ɵfac = function DxiFormEmailRuleModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DxiFormEmailRuleModule)();
  };
  /** @nocollapse */
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: DxiFormEmailRuleModule
  });
  /** @nocollapse */
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DxiFormEmailRuleModule, [{
    type: NgModule,
    args: [{
      declarations: [DxiFormEmailRuleComponent],
      exports: [DxiFormEmailRuleComponent]
    }]
  }], null, null);
})();

/*!
 * devextreme-angular
 * Version: 24.2.3
 * Build date: Fri Dec 06 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
class DxiFormEmptyItemComponent extends CollectionNestedOption {
  get colSpan() {
    return this._getOption('colSpan');
  }
  set colSpan(value) {
    this._setOption('colSpan', value);
  }
  get cssClass() {
    return this._getOption('cssClass');
  }
  set cssClass(value) {
    this._setOption('cssClass', value);
  }
  get itemType() {
    return this._getOption('itemType');
  }
  set itemType(value) {
    this._setOption('itemType', value);
  }
  get name() {
    return this._getOption('name');
  }
  set name(value) {
    this._setOption('name', value);
  }
  get visible() {
    return this._getOption('visible');
  }
  set visible(value) {
    this._setOption('visible', value);
  }
  get visibleIndex() {
    return this._getOption('visibleIndex');
  }
  set visibleIndex(value) {
    this._setOption('visibleIndex', value);
  }
  get _optionPath() {
    return 'items';
  }
  constructor(parentOptionHost, optionHost) {
    super();
    parentOptionHost.setNestedOption(this);
    optionHost.setHost(this, this._fullOptionPath.bind(this));
  }
  ngOnDestroy() {
    this._deleteRemovedOptions(this._fullOptionPath());
  }
  /** @nocollapse */
  static ɵfac = function DxiFormEmptyItemComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DxiFormEmptyItemComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
  };
  /** @nocollapse */
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DxiFormEmptyItemComponent,
    selectors: [["dxi-form-empty-item"]],
    inputs: {
      colSpan: "colSpan",
      cssClass: "cssClass",
      itemType: "itemType",
      name: "name",
      visible: "visible",
      visibleIndex: "visibleIndex"
    },
    standalone: false,
    features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
    decls: 0,
    vars: 0,
    template: function DxiFormEmptyItemComponent_Template(rf, ctx) {},
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DxiFormEmptyItemComponent, [{
    type: Component,
    args: [{
      selector: 'dxi-form-empty-item',
      template: '',
      providers: [NestedOptionHost]
    }]
  }], () => [{
    type: i1.NestedOptionHost,
    decorators: [{
      type: SkipSelf
    }, {
      type: Host
    }]
  }, {
    type: i1.NestedOptionHost,
    decorators: [{
      type: Host
    }]
  }], {
    colSpan: [{
      type: Input
    }],
    cssClass: [{
      type: Input
    }],
    itemType: [{
      type: Input
    }],
    name: [{
      type: Input
    }],
    visible: [{
      type: Input
    }],
    visibleIndex: [{
      type: Input
    }]
  });
})();
class DxiFormEmptyItemModule {
  /** @nocollapse */static ɵfac = function DxiFormEmptyItemModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DxiFormEmptyItemModule)();
  };
  /** @nocollapse */
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: DxiFormEmptyItemModule
  });
  /** @nocollapse */
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DxiFormEmptyItemModule, [{
    type: NgModule,
    args: [{
      declarations: [DxiFormEmptyItemComponent],
      exports: [DxiFormEmptyItemComponent]
    }]
  }], null, null);
})();

/*!
 * devextreme-angular
 * Version: 24.2.3
 * Build date: Fri Dec 06 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
class DxiFormGroupItemComponent extends CollectionNestedOption {
  renderer;
  document;
  element;
  get alignItemLabels() {
    return this._getOption('alignItemLabels');
  }
  set alignItemLabels(value) {
    this._setOption('alignItemLabels', value);
  }
  get caption() {
    return this._getOption('caption');
  }
  set caption(value) {
    this._setOption('caption', value);
  }
  get captionTemplate() {
    return this._getOption('captionTemplate');
  }
  set captionTemplate(value) {
    this._setOption('captionTemplate', value);
  }
  get colCount() {
    return this._getOption('colCount');
  }
  set colCount(value) {
    this._setOption('colCount', value);
  }
  get colCountByScreen() {
    return this._getOption('colCountByScreen');
  }
  set colCountByScreen(value) {
    this._setOption('colCountByScreen', value);
  }
  get colSpan() {
    return this._getOption('colSpan');
  }
  set colSpan(value) {
    this._setOption('colSpan', value);
  }
  get cssClass() {
    return this._getOption('cssClass');
  }
  set cssClass(value) {
    this._setOption('cssClass', value);
  }
  get items() {
    return this._getOption('items');
  }
  set items(value) {
    this._setOption('items', value);
  }
  get itemType() {
    return this._getOption('itemType');
  }
  set itemType(value) {
    this._setOption('itemType', value);
  }
  get name() {
    return this._getOption('name');
  }
  set name(value) {
    this._setOption('name', value);
  }
  get template() {
    return this._getOption('template');
  }
  set template(value) {
    this._setOption('template', value);
  }
  get visible() {
    return this._getOption('visible');
  }
  set visible(value) {
    this._setOption('visible', value);
  }
  get visibleIndex() {
    return this._getOption('visibleIndex');
  }
  set visibleIndex(value) {
    this._setOption('visibleIndex', value);
  }
  get _optionPath() {
    return 'items';
  }
  constructor(parentOptionHost, optionHost, renderer, document, templateHost, element) {
    super();
    this.renderer = renderer;
    this.document = document;
    this.element = element;
    parentOptionHost.setNestedOption(this);
    optionHost.setHost(this, this._fullOptionPath.bind(this));
    templateHost.setHost(this);
  }
  setTemplate(template) {
    this.template = template;
  }
  ngAfterViewInit() {
    extractTemplate(this, this.element, this.renderer, this.document);
  }
  ngOnDestroy() {
    this._deleteRemovedOptions(this._fullOptionPath());
  }
  /** @nocollapse */
  static ɵfac = function DxiFormGroupItemComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DxiFormGroupItemComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i1.DxTemplateHost, 1), i0.ɵɵdirectiveInject(i0.ElementRef));
  };
  /** @nocollapse */
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DxiFormGroupItemComponent,
    selectors: [["dxi-form-group-item"]],
    inputs: {
      alignItemLabels: "alignItemLabels",
      caption: "caption",
      captionTemplate: "captionTemplate",
      colCount: "colCount",
      colCountByScreen: "colCountByScreen",
      colSpan: "colSpan",
      cssClass: "cssClass",
      items: "items",
      itemType: "itemType",
      name: "name",
      template: "template",
      visible: "visible",
      visibleIndex: "visibleIndex"
    },
    standalone: false,
    features: [i0.ɵɵProvidersFeature([NestedOptionHost, DxTemplateHost]), i0.ɵɵInheritDefinitionFeature],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function DxiFormGroupItemComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    styles: ["[_nghost-%COMP%]{display:block}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DxiFormGroupItemComponent, [{
    type: Component,
    args: [{
      selector: 'dxi-form-group-item',
      template: '<ng-content></ng-content>',
      providers: [NestedOptionHost, DxTemplateHost],
      styles: [":host{display:block}\n"]
    }]
  }], () => [{
    type: i1.NestedOptionHost,
    decorators: [{
      type: SkipSelf
    }, {
      type: Host
    }]
  }, {
    type: i1.NestedOptionHost,
    decorators: [{
      type: Host
    }]
  }, {
    type: i0.Renderer2
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [DOCUMENT]
    }]
  }, {
    type: i1.DxTemplateHost,
    decorators: [{
      type: Host
    }]
  }, {
    type: i0.ElementRef
  }], {
    alignItemLabels: [{
      type: Input
    }],
    caption: [{
      type: Input
    }],
    captionTemplate: [{
      type: Input
    }],
    colCount: [{
      type: Input
    }],
    colCountByScreen: [{
      type: Input
    }],
    colSpan: [{
      type: Input
    }],
    cssClass: [{
      type: Input
    }],
    items: [{
      type: Input
    }],
    itemType: [{
      type: Input
    }],
    name: [{
      type: Input
    }],
    template: [{
      type: Input
    }],
    visible: [{
      type: Input
    }],
    visibleIndex: [{
      type: Input
    }]
  });
})();
class DxiFormGroupItemModule {
  /** @nocollapse */static ɵfac = function DxiFormGroupItemModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DxiFormGroupItemModule)();
  };
  /** @nocollapse */
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: DxiFormGroupItemModule
  });
  /** @nocollapse */
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DxiFormGroupItemModule, [{
    type: NgModule,
    args: [{
      declarations: [DxiFormGroupItemComponent],
      exports: [DxiFormGroupItemComponent]
    }]
  }], null, null);
})();

/*!
 * devextreme-angular
 * Version: 24.2.3
 * Build date: Fri Dec 06 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
class DxiFormNumericRuleComponent extends CollectionNestedOption {
  get ignoreEmptyValue() {
    return this._getOption('ignoreEmptyValue');
  }
  set ignoreEmptyValue(value) {
    this._setOption('ignoreEmptyValue', value);
  }
  get message() {
    return this._getOption('message');
  }
  set message(value) {
    this._setOption('message', value);
  }
  get type() {
    return this._getOption('type');
  }
  set type(value) {
    this._setOption('type', value);
  }
  get _optionPath() {
    return 'validationRules';
  }
  constructor(parentOptionHost, optionHost) {
    super();
    parentOptionHost.setNestedOption(this);
    optionHost.setHost(this, this._fullOptionPath.bind(this));
  }
  ngOnDestroy() {
    this._deleteRemovedOptions(this._fullOptionPath());
  }
  /** @nocollapse */
  static ɵfac = function DxiFormNumericRuleComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DxiFormNumericRuleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
  };
  /** @nocollapse */
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DxiFormNumericRuleComponent,
    selectors: [["dxi-form-numeric-rule"]],
    inputs: {
      ignoreEmptyValue: "ignoreEmptyValue",
      message: "message",
      type: "type"
    },
    standalone: false,
    features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
    decls: 0,
    vars: 0,
    template: function DxiFormNumericRuleComponent_Template(rf, ctx) {},
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DxiFormNumericRuleComponent, [{
    type: Component,
    args: [{
      selector: 'dxi-form-numeric-rule',
      template: '',
      providers: [NestedOptionHost]
    }]
  }], () => [{
    type: i1.NestedOptionHost,
    decorators: [{
      type: SkipSelf
    }, {
      type: Host
    }]
  }, {
    type: i1.NestedOptionHost,
    decorators: [{
      type: Host
    }]
  }], {
    ignoreEmptyValue: [{
      type: Input
    }],
    message: [{
      type: Input
    }],
    type: [{
      type: Input
    }]
  });
})();
class DxiFormNumericRuleModule {
  /** @nocollapse */static ɵfac = function DxiFormNumericRuleModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DxiFormNumericRuleModule)();
  };
  /** @nocollapse */
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: DxiFormNumericRuleModule
  });
  /** @nocollapse */
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DxiFormNumericRuleModule, [{
    type: NgModule,
    args: [{
      declarations: [DxiFormNumericRuleComponent],
      exports: [DxiFormNumericRuleComponent]
    }]
  }], null, null);
})();

/*!
 * devextreme-angular
 * Version: 24.2.3
 * Build date: Fri Dec 06 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
class DxiFormPatternRuleComponent extends CollectionNestedOption {
  get ignoreEmptyValue() {
    return this._getOption('ignoreEmptyValue');
  }
  set ignoreEmptyValue(value) {
    this._setOption('ignoreEmptyValue', value);
  }
  get message() {
    return this._getOption('message');
  }
  set message(value) {
    this._setOption('message', value);
  }
  get pattern() {
    return this._getOption('pattern');
  }
  set pattern(value) {
    this._setOption('pattern', value);
  }
  get type() {
    return this._getOption('type');
  }
  set type(value) {
    this._setOption('type', value);
  }
  get _optionPath() {
    return 'validationRules';
  }
  constructor(parentOptionHost, optionHost) {
    super();
    parentOptionHost.setNestedOption(this);
    optionHost.setHost(this, this._fullOptionPath.bind(this));
  }
  ngOnDestroy() {
    this._deleteRemovedOptions(this._fullOptionPath());
  }
  /** @nocollapse */
  static ɵfac = function DxiFormPatternRuleComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DxiFormPatternRuleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
  };
  /** @nocollapse */
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DxiFormPatternRuleComponent,
    selectors: [["dxi-form-pattern-rule"]],
    inputs: {
      ignoreEmptyValue: "ignoreEmptyValue",
      message: "message",
      pattern: "pattern",
      type: "type"
    },
    standalone: false,
    features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
    decls: 0,
    vars: 0,
    template: function DxiFormPatternRuleComponent_Template(rf, ctx) {},
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DxiFormPatternRuleComponent, [{
    type: Component,
    args: [{
      selector: 'dxi-form-pattern-rule',
      template: '',
      providers: [NestedOptionHost]
    }]
  }], () => [{
    type: i1.NestedOptionHost,
    decorators: [{
      type: SkipSelf
    }, {
      type: Host
    }]
  }, {
    type: i1.NestedOptionHost,
    decorators: [{
      type: Host
    }]
  }], {
    ignoreEmptyValue: [{
      type: Input
    }],
    message: [{
      type: Input
    }],
    pattern: [{
      type: Input
    }],
    type: [{
      type: Input
    }]
  });
})();
class DxiFormPatternRuleModule {
  /** @nocollapse */static ɵfac = function DxiFormPatternRuleModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DxiFormPatternRuleModule)();
  };
  /** @nocollapse */
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: DxiFormPatternRuleModule
  });
  /** @nocollapse */
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DxiFormPatternRuleModule, [{
    type: NgModule,
    args: [{
      declarations: [DxiFormPatternRuleComponent],
      exports: [DxiFormPatternRuleComponent]
    }]
  }], null, null);
})();

/*!
 * devextreme-angular
 * Version: 24.2.3
 * Build date: Fri Dec 06 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
class DxiFormRangeRuleComponent extends CollectionNestedOption {
  get ignoreEmptyValue() {
    return this._getOption('ignoreEmptyValue');
  }
  set ignoreEmptyValue(value) {
    this._setOption('ignoreEmptyValue', value);
  }
  get max() {
    return this._getOption('max');
  }
  set max(value) {
    this._setOption('max', value);
  }
  get message() {
    return this._getOption('message');
  }
  set message(value) {
    this._setOption('message', value);
  }
  get min() {
    return this._getOption('min');
  }
  set min(value) {
    this._setOption('min', value);
  }
  get reevaluate() {
    return this._getOption('reevaluate');
  }
  set reevaluate(value) {
    this._setOption('reevaluate', value);
  }
  get type() {
    return this._getOption('type');
  }
  set type(value) {
    this._setOption('type', value);
  }
  get _optionPath() {
    return 'validationRules';
  }
  constructor(parentOptionHost, optionHost) {
    super();
    parentOptionHost.setNestedOption(this);
    optionHost.setHost(this, this._fullOptionPath.bind(this));
  }
  ngOnDestroy() {
    this._deleteRemovedOptions(this._fullOptionPath());
  }
  /** @nocollapse */
  static ɵfac = function DxiFormRangeRuleComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DxiFormRangeRuleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
  };
  /** @nocollapse */
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DxiFormRangeRuleComponent,
    selectors: [["dxi-form-range-rule"]],
    inputs: {
      ignoreEmptyValue: "ignoreEmptyValue",
      max: "max",
      message: "message",
      min: "min",
      reevaluate: "reevaluate",
      type: "type"
    },
    standalone: false,
    features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
    decls: 0,
    vars: 0,
    template: function DxiFormRangeRuleComponent_Template(rf, ctx) {},
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DxiFormRangeRuleComponent, [{
    type: Component,
    args: [{
      selector: 'dxi-form-range-rule',
      template: '',
      providers: [NestedOptionHost]
    }]
  }], () => [{
    type: i1.NestedOptionHost,
    decorators: [{
      type: SkipSelf
    }, {
      type: Host
    }]
  }, {
    type: i1.NestedOptionHost,
    decorators: [{
      type: Host
    }]
  }], {
    ignoreEmptyValue: [{
      type: Input
    }],
    max: [{
      type: Input
    }],
    message: [{
      type: Input
    }],
    min: [{
      type: Input
    }],
    reevaluate: [{
      type: Input
    }],
    type: [{
      type: Input
    }]
  });
})();
class DxiFormRangeRuleModule {
  /** @nocollapse */static ɵfac = function DxiFormRangeRuleModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DxiFormRangeRuleModule)();
  };
  /** @nocollapse */
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: DxiFormRangeRuleModule
  });
  /** @nocollapse */
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DxiFormRangeRuleModule, [{
    type: NgModule,
    args: [{
      declarations: [DxiFormRangeRuleComponent],
      exports: [DxiFormRangeRuleComponent]
    }]
  }], null, null);
})();

/*!
 * devextreme-angular
 * Version: 24.2.3
 * Build date: Fri Dec 06 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
class DxiFormRequiredRuleComponent extends CollectionNestedOption {
  get message() {
    return this._getOption('message');
  }
  set message(value) {
    this._setOption('message', value);
  }
  get trim() {
    return this._getOption('trim');
  }
  set trim(value) {
    this._setOption('trim', value);
  }
  get type() {
    return this._getOption('type');
  }
  set type(value) {
    this._setOption('type', value);
  }
  get _optionPath() {
    return 'validationRules';
  }
  constructor(parentOptionHost, optionHost) {
    super();
    parentOptionHost.setNestedOption(this);
    optionHost.setHost(this, this._fullOptionPath.bind(this));
  }
  ngOnDestroy() {
    this._deleteRemovedOptions(this._fullOptionPath());
  }
  /** @nocollapse */
  static ɵfac = function DxiFormRequiredRuleComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DxiFormRequiredRuleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
  };
  /** @nocollapse */
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DxiFormRequiredRuleComponent,
    selectors: [["dxi-form-required-rule"]],
    inputs: {
      message: "message",
      trim: "trim",
      type: "type"
    },
    standalone: false,
    features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
    decls: 0,
    vars: 0,
    template: function DxiFormRequiredRuleComponent_Template(rf, ctx) {},
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DxiFormRequiredRuleComponent, [{
    type: Component,
    args: [{
      selector: 'dxi-form-required-rule',
      template: '',
      providers: [NestedOptionHost]
    }]
  }], () => [{
    type: i1.NestedOptionHost,
    decorators: [{
      type: SkipSelf
    }, {
      type: Host
    }]
  }, {
    type: i1.NestedOptionHost,
    decorators: [{
      type: Host
    }]
  }], {
    message: [{
      type: Input
    }],
    trim: [{
      type: Input
    }],
    type: [{
      type: Input
    }]
  });
})();
class DxiFormRequiredRuleModule {
  /** @nocollapse */static ɵfac = function DxiFormRequiredRuleModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DxiFormRequiredRuleModule)();
  };
  /** @nocollapse */
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: DxiFormRequiredRuleModule
  });
  /** @nocollapse */
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DxiFormRequiredRuleModule, [{
    type: NgModule,
    args: [{
      declarations: [DxiFormRequiredRuleComponent],
      exports: [DxiFormRequiredRuleComponent]
    }]
  }], null, null);
})();

/*!
 * devextreme-angular
 * Version: 24.2.3
 * Build date: Fri Dec 06 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
class DxiFormStringLengthRuleComponent extends CollectionNestedOption {
  get ignoreEmptyValue() {
    return this._getOption('ignoreEmptyValue');
  }
  set ignoreEmptyValue(value) {
    this._setOption('ignoreEmptyValue', value);
  }
  get max() {
    return this._getOption('max');
  }
  set max(value) {
    this._setOption('max', value);
  }
  get message() {
    return this._getOption('message');
  }
  set message(value) {
    this._setOption('message', value);
  }
  get min() {
    return this._getOption('min');
  }
  set min(value) {
    this._setOption('min', value);
  }
  get trim() {
    return this._getOption('trim');
  }
  set trim(value) {
    this._setOption('trim', value);
  }
  get type() {
    return this._getOption('type');
  }
  set type(value) {
    this._setOption('type', value);
  }
  get _optionPath() {
    return 'validationRules';
  }
  constructor(parentOptionHost, optionHost) {
    super();
    parentOptionHost.setNestedOption(this);
    optionHost.setHost(this, this._fullOptionPath.bind(this));
  }
  ngOnDestroy() {
    this._deleteRemovedOptions(this._fullOptionPath());
  }
  /** @nocollapse */
  static ɵfac = function DxiFormStringLengthRuleComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DxiFormStringLengthRuleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
  };
  /** @nocollapse */
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DxiFormStringLengthRuleComponent,
    selectors: [["dxi-form-string-length-rule"]],
    inputs: {
      ignoreEmptyValue: "ignoreEmptyValue",
      max: "max",
      message: "message",
      min: "min",
      trim: "trim",
      type: "type"
    },
    standalone: false,
    features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
    decls: 0,
    vars: 0,
    template: function DxiFormStringLengthRuleComponent_Template(rf, ctx) {},
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DxiFormStringLengthRuleComponent, [{
    type: Component,
    args: [{
      selector: 'dxi-form-string-length-rule',
      template: '',
      providers: [NestedOptionHost]
    }]
  }], () => [{
    type: i1.NestedOptionHost,
    decorators: [{
      type: SkipSelf
    }, {
      type: Host
    }]
  }, {
    type: i1.NestedOptionHost,
    decorators: [{
      type: Host
    }]
  }], {
    ignoreEmptyValue: [{
      type: Input
    }],
    max: [{
      type: Input
    }],
    message: [{
      type: Input
    }],
    min: [{
      type: Input
    }],
    trim: [{
      type: Input
    }],
    type: [{
      type: Input
    }]
  });
})();
class DxiFormStringLengthRuleModule {
  /** @nocollapse */static ɵfac = function DxiFormStringLengthRuleModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DxiFormStringLengthRuleModule)();
  };
  /** @nocollapse */
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: DxiFormStringLengthRuleModule
  });
  /** @nocollapse */
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DxiFormStringLengthRuleModule, [{
    type: NgModule,
    args: [{
      declarations: [DxiFormStringLengthRuleComponent],
      exports: [DxiFormStringLengthRuleComponent]
    }]
  }], null, null);
})();

/*!
 * devextreme-angular
 * Version: 24.2.3
 * Build date: Fri Dec 06 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
class DxiFormTabComponent extends CollectionNestedOption {
  renderer;
  document;
  element;
  get alignItemLabels() {
    return this._getOption('alignItemLabels');
  }
  set alignItemLabels(value) {
    this._setOption('alignItemLabels', value);
  }
  get badge() {
    return this._getOption('badge');
  }
  set badge(value) {
    this._setOption('badge', value);
  }
  get colCount() {
    return this._getOption('colCount');
  }
  set colCount(value) {
    this._setOption('colCount', value);
  }
  get colCountByScreen() {
    return this._getOption('colCountByScreen');
  }
  set colCountByScreen(value) {
    this._setOption('colCountByScreen', value);
  }
  get disabled() {
    return this._getOption('disabled');
  }
  set disabled(value) {
    this._setOption('disabled', value);
  }
  get icon() {
    return this._getOption('icon');
  }
  set icon(value) {
    this._setOption('icon', value);
  }
  get items() {
    return this._getOption('items');
  }
  set items(value) {
    this._setOption('items', value);
  }
  get tabTemplate() {
    return this._getOption('tabTemplate');
  }
  set tabTemplate(value) {
    this._setOption('tabTemplate', value);
  }
  get template() {
    return this._getOption('template');
  }
  set template(value) {
    this._setOption('template', value);
  }
  get title() {
    return this._getOption('title');
  }
  set title(value) {
    this._setOption('title', value);
  }
  get _optionPath() {
    return 'tabs';
  }
  constructor(parentOptionHost, optionHost, renderer, document, templateHost, element) {
    super();
    this.renderer = renderer;
    this.document = document;
    this.element = element;
    parentOptionHost.setNestedOption(this);
    optionHost.setHost(this, this._fullOptionPath.bind(this));
    templateHost.setHost(this);
  }
  setTemplate(template) {
    this.template = template;
  }
  ngAfterViewInit() {
    extractTemplate(this, this.element, this.renderer, this.document);
  }
  ngOnDestroy() {
    this._deleteRemovedOptions(this._fullOptionPath());
  }
  /** @nocollapse */
  static ɵfac = function DxiFormTabComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DxiFormTabComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i1.DxTemplateHost, 1), i0.ɵɵdirectiveInject(i0.ElementRef));
  };
  /** @nocollapse */
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DxiFormTabComponent,
    selectors: [["dxi-form-tab"]],
    inputs: {
      alignItemLabels: "alignItemLabels",
      badge: "badge",
      colCount: "colCount",
      colCountByScreen: "colCountByScreen",
      disabled: "disabled",
      icon: "icon",
      items: "items",
      tabTemplate: "tabTemplate",
      template: "template",
      title: "title"
    },
    standalone: false,
    features: [i0.ɵɵProvidersFeature([NestedOptionHost, DxTemplateHost]), i0.ɵɵInheritDefinitionFeature],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function DxiFormTabComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    styles: ["[_nghost-%COMP%]{display:block}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DxiFormTabComponent, [{
    type: Component,
    args: [{
      selector: 'dxi-form-tab',
      template: '<ng-content></ng-content>',
      providers: [NestedOptionHost, DxTemplateHost],
      styles: [":host{display:block}\n"]
    }]
  }], () => [{
    type: i1.NestedOptionHost,
    decorators: [{
      type: SkipSelf
    }, {
      type: Host
    }]
  }, {
    type: i1.NestedOptionHost,
    decorators: [{
      type: Host
    }]
  }, {
    type: i0.Renderer2
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [DOCUMENT]
    }]
  }, {
    type: i1.DxTemplateHost,
    decorators: [{
      type: Host
    }]
  }, {
    type: i0.ElementRef
  }], {
    alignItemLabels: [{
      type: Input
    }],
    badge: [{
      type: Input
    }],
    colCount: [{
      type: Input
    }],
    colCountByScreen: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    icon: [{
      type: Input
    }],
    items: [{
      type: Input
    }],
    tabTemplate: [{
      type: Input
    }],
    template: [{
      type: Input
    }],
    title: [{
      type: Input
    }]
  });
})();
class DxiFormTabModule {
  /** @nocollapse */static ɵfac = function DxiFormTabModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DxiFormTabModule)();
  };
  /** @nocollapse */
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: DxiFormTabModule
  });
  /** @nocollapse */
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DxiFormTabModule, [{
    type: NgModule,
    args: [{
      declarations: [DxiFormTabComponent],
      exports: [DxiFormTabComponent]
    }]
  }], null, null);
})();

/*!
 * devextreme-angular
 * Version: 24.2.3
 * Build date: Fri Dec 06 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
class DxiFormValidationRuleComponent extends CollectionNestedOption {
  get message() {
    return this._getOption('message');
  }
  set message(value) {
    this._setOption('message', value);
  }
  get trim() {
    return this._getOption('trim');
  }
  set trim(value) {
    this._setOption('trim', value);
  }
  get type() {
    return this._getOption('type');
  }
  set type(value) {
    this._setOption('type', value);
  }
  get ignoreEmptyValue() {
    return this._getOption('ignoreEmptyValue');
  }
  set ignoreEmptyValue(value) {
    this._setOption('ignoreEmptyValue', value);
  }
  get max() {
    return this._getOption('max');
  }
  set max(value) {
    this._setOption('max', value);
  }
  get min() {
    return this._getOption('min');
  }
  set min(value) {
    this._setOption('min', value);
  }
  get reevaluate() {
    return this._getOption('reevaluate');
  }
  set reevaluate(value) {
    this._setOption('reevaluate', value);
  }
  get validationCallback() {
    return this._getOption('validationCallback');
  }
  set validationCallback(value) {
    this._setOption('validationCallback', value);
  }
  get comparisonTarget() {
    return this._getOption('comparisonTarget');
  }
  set comparisonTarget(value) {
    this._setOption('comparisonTarget', value);
  }
  get comparisonType() {
    return this._getOption('comparisonType');
  }
  set comparisonType(value) {
    this._setOption('comparisonType', value);
  }
  get pattern() {
    return this._getOption('pattern');
  }
  set pattern(value) {
    this._setOption('pattern', value);
  }
  get _optionPath() {
    return 'validationRules';
  }
  constructor(parentOptionHost, optionHost) {
    super();
    parentOptionHost.setNestedOption(this);
    optionHost.setHost(this, this._fullOptionPath.bind(this));
  }
  ngOnDestroy() {
    this._deleteRemovedOptions(this._fullOptionPath());
  }
  /** @nocollapse */
  static ɵfac = function DxiFormValidationRuleComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DxiFormValidationRuleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
  };
  /** @nocollapse */
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DxiFormValidationRuleComponent,
    selectors: [["dxi-form-validation-rule"]],
    inputs: {
      message: "message",
      trim: "trim",
      type: "type",
      ignoreEmptyValue: "ignoreEmptyValue",
      max: "max",
      min: "min",
      reevaluate: "reevaluate",
      validationCallback: "validationCallback",
      comparisonTarget: "comparisonTarget",
      comparisonType: "comparisonType",
      pattern: "pattern"
    },
    standalone: false,
    features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
    decls: 0,
    vars: 0,
    template: function DxiFormValidationRuleComponent_Template(rf, ctx) {},
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DxiFormValidationRuleComponent, [{
    type: Component,
    args: [{
      selector: 'dxi-form-validation-rule',
      template: '',
      providers: [NestedOptionHost]
    }]
  }], () => [{
    type: i1.NestedOptionHost,
    decorators: [{
      type: SkipSelf
    }, {
      type: Host
    }]
  }, {
    type: i1.NestedOptionHost,
    decorators: [{
      type: Host
    }]
  }], {
    message: [{
      type: Input
    }],
    trim: [{
      type: Input
    }],
    type: [{
      type: Input
    }],
    ignoreEmptyValue: [{
      type: Input
    }],
    max: [{
      type: Input
    }],
    min: [{
      type: Input
    }],
    reevaluate: [{
      type: Input
    }],
    validationCallback: [{
      type: Input
    }],
    comparisonTarget: [{
      type: Input
    }],
    comparisonType: [{
      type: Input
    }],
    pattern: [{
      type: Input
    }]
  });
})();
class DxiFormValidationRuleModule {
  /** @nocollapse */static ɵfac = function DxiFormValidationRuleModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DxiFormValidationRuleModule)();
  };
  /** @nocollapse */
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: DxiFormValidationRuleModule
  });
  /** @nocollapse */
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DxiFormValidationRuleModule, [{
    type: NgModule,
    args: [{
      declarations: [DxiFormValidationRuleComponent],
      exports: [DxiFormValidationRuleComponent]
    }]
  }], null, null);
})();

/*!
 * devextreme-angular
 * Version: 24.2.3
 * Build date: Fri Dec 06 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
class DxiFormItemComponent extends CollectionNestedOption {
  renderer;
  document;
  element;
  get badge() {
    return this._getOption('badge');
  }
  set badge(value) {
    this._setOption('badge', value);
  }
  get disabled() {
    return this._getOption('disabled');
  }
  set disabled(value) {
    this._setOption('disabled', value);
  }
  get html() {
    return this._getOption('html');
  }
  set html(value) {
    this._setOption('html', value);
  }
  get icon() {
    return this._getOption('icon');
  }
  set icon(value) {
    this._setOption('icon', value);
  }
  get tabTemplate() {
    return this._getOption('tabTemplate');
  }
  set tabTemplate(value) {
    this._setOption('tabTemplate', value);
  }
  get template() {
    return this._getOption('template');
  }
  set template(value) {
    this._setOption('template', value);
  }
  get text() {
    return this._getOption('text');
  }
  set text(value) {
    this._setOption('text', value);
  }
  get title() {
    return this._getOption('title');
  }
  set title(value) {
    this._setOption('title', value);
  }
  get visible() {
    return this._getOption('visible');
  }
  set visible(value) {
    this._setOption('visible', value);
  }
  get colSpan() {
    return this._getOption('colSpan');
  }
  set colSpan(value) {
    this._setOption('colSpan', value);
  }
  get cssClass() {
    return this._getOption('cssClass');
  }
  set cssClass(value) {
    this._setOption('cssClass', value);
  }
  get dataField() {
    return this._getOption('dataField');
  }
  set dataField(value) {
    this._setOption('dataField', value);
  }
  get editorOptions() {
    return this._getOption('editorOptions');
  }
  set editorOptions(value) {
    this._setOption('editorOptions', value);
  }
  get editorType() {
    return this._getOption('editorType');
  }
  set editorType(value) {
    this._setOption('editorType', value);
  }
  get helpText() {
    return this._getOption('helpText');
  }
  set helpText(value) {
    this._setOption('helpText', value);
  }
  get isRequired() {
    return this._getOption('isRequired');
  }
  set isRequired(value) {
    this._setOption('isRequired', value);
  }
  get itemType() {
    return this._getOption('itemType');
  }
  set itemType(value) {
    this._setOption('itemType', value);
  }
  get label() {
    return this._getOption('label');
  }
  set label(value) {
    this._setOption('label', value);
  }
  get name() {
    return this._getOption('name');
  }
  set name(value) {
    this._setOption('name', value);
  }
  get validationRules() {
    return this._getOption('validationRules');
  }
  set validationRules(value) {
    this._setOption('validationRules', value);
  }
  get visibleIndex() {
    return this._getOption('visibleIndex');
  }
  set visibleIndex(value) {
    this._setOption('visibleIndex', value);
  }
  get alignItemLabels() {
    return this._getOption('alignItemLabels');
  }
  set alignItemLabels(value) {
    this._setOption('alignItemLabels', value);
  }
  get caption() {
    return this._getOption('caption');
  }
  set caption(value) {
    this._setOption('caption', value);
  }
  get captionTemplate() {
    return this._getOption('captionTemplate');
  }
  set captionTemplate(value) {
    this._setOption('captionTemplate', value);
  }
  get colCount() {
    return this._getOption('colCount');
  }
  set colCount(value) {
    this._setOption('colCount', value);
  }
  get colCountByScreen() {
    return this._getOption('colCountByScreen');
  }
  set colCountByScreen(value) {
    this._setOption('colCountByScreen', value);
  }
  get items() {
    return this._getOption('items');
  }
  set items(value) {
    this._setOption('items', value);
  }
  get tabPanelOptions() {
    return this._getOption('tabPanelOptions');
  }
  set tabPanelOptions(value) {
    this._setOption('tabPanelOptions', value);
  }
  get tabs() {
    return this._getOption('tabs');
  }
  set tabs(value) {
    this._setOption('tabs', value);
  }
  get buttonOptions() {
    return this._getOption('buttonOptions');
  }
  set buttonOptions(value) {
    this._setOption('buttonOptions', value);
  }
  get horizontalAlignment() {
    return this._getOption('horizontalAlignment');
  }
  set horizontalAlignment(value) {
    this._setOption('horizontalAlignment', value);
  }
  get verticalAlignment() {
    return this._getOption('verticalAlignment');
  }
  set verticalAlignment(value) {
    this._setOption('verticalAlignment', value);
  }
  get _optionPath() {
    return 'items';
  }
  get asyncRulesChildren() {
    return this._getOption('validationRules');
  }
  set asyncRulesChildren(value) {
    this.setChildren('validationRules', value);
  }
  get compareRulesChildren() {
    return this._getOption('validationRules');
  }
  set compareRulesChildren(value) {
    this.setChildren('validationRules', value);
  }
  get customRulesChildren() {
    return this._getOption('validationRules');
  }
  set customRulesChildren(value) {
    this.setChildren('validationRules', value);
  }
  get emailRulesChildren() {
    return this._getOption('validationRules');
  }
  set emailRulesChildren(value) {
    this.setChildren('validationRules', value);
  }
  get numericRulesChildren() {
    return this._getOption('validationRules');
  }
  set numericRulesChildren(value) {
    this.setChildren('validationRules', value);
  }
  get patternRulesChildren() {
    return this._getOption('validationRules');
  }
  set patternRulesChildren(value) {
    this.setChildren('validationRules', value);
  }
  get rangeRulesChildren() {
    return this._getOption('validationRules');
  }
  set rangeRulesChildren(value) {
    this.setChildren('validationRules', value);
  }
  get requiredRulesChildren() {
    return this._getOption('validationRules');
  }
  set requiredRulesChildren(value) {
    this.setChildren('validationRules', value);
  }
  get stringLengthRulesChildren() {
    return this._getOption('validationRules');
  }
  set stringLengthRulesChildren(value) {
    this.setChildren('validationRules', value);
  }
  get tabsChildren() {
    return this._getOption('tabs');
  }
  set tabsChildren(value) {
    this.setChildren('tabs', value);
  }
  get validationRulesChildren() {
    return this._getOption('validationRules');
  }
  set validationRulesChildren(value) {
    this.setChildren('validationRules', value);
  }
  constructor(parentOptionHost, optionHost, renderer, document, templateHost, element) {
    super();
    this.renderer = renderer;
    this.document = document;
    this.element = element;
    parentOptionHost.setNestedOption(this);
    optionHost.setHost(this, this._fullOptionPath.bind(this));
    templateHost.setHost(this);
  }
  setTemplate(template) {
    this.template = template;
  }
  ngAfterViewInit() {
    extractTemplate(this, this.element, this.renderer, this.document);
  }
  ngOnDestroy() {
    this._deleteRemovedOptions(this._fullOptionPath());
  }
  /** @nocollapse */
  static ɵfac = function DxiFormItemComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DxiFormItemComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i1.DxTemplateHost, 1), i0.ɵɵdirectiveInject(i0.ElementRef));
  };
  /** @nocollapse */
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DxiFormItemComponent,
    selectors: [["dxi-form-item"]],
    contentQueries: function DxiFormItemComponent_ContentQueries(rf, ctx, dirIndex) {
      if (rf & 1) {
        i0.ɵɵcontentQuery(dirIndex, DxiFormAsyncRuleComponent, 4);
        i0.ɵɵcontentQuery(dirIndex, DxiFormCompareRuleComponent, 4);
        i0.ɵɵcontentQuery(dirIndex, DxiFormCustomRuleComponent, 4);
        i0.ɵɵcontentQuery(dirIndex, DxiFormEmailRuleComponent, 4);
        i0.ɵɵcontentQuery(dirIndex, DxiFormNumericRuleComponent, 4);
        i0.ɵɵcontentQuery(dirIndex, DxiFormPatternRuleComponent, 4);
        i0.ɵɵcontentQuery(dirIndex, DxiFormRangeRuleComponent, 4);
        i0.ɵɵcontentQuery(dirIndex, DxiFormRequiredRuleComponent, 4);
        i0.ɵɵcontentQuery(dirIndex, DxiFormStringLengthRuleComponent, 4);
        i0.ɵɵcontentQuery(dirIndex, DxiFormTabComponent, 4);
        i0.ɵɵcontentQuery(dirIndex, DxiFormValidationRuleComponent, 4);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.asyncRulesChildren = _t);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.compareRulesChildren = _t);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.customRulesChildren = _t);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.emailRulesChildren = _t);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.numericRulesChildren = _t);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.patternRulesChildren = _t);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rangeRulesChildren = _t);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.requiredRulesChildren = _t);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.stringLengthRulesChildren = _t);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tabsChildren = _t);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.validationRulesChildren = _t);
      }
    },
    inputs: {
      badge: "badge",
      disabled: "disabled",
      html: "html",
      icon: "icon",
      tabTemplate: "tabTemplate",
      template: "template",
      text: "text",
      title: "title",
      visible: "visible",
      colSpan: "colSpan",
      cssClass: "cssClass",
      dataField: "dataField",
      editorOptions: "editorOptions",
      editorType: "editorType",
      helpText: "helpText",
      isRequired: "isRequired",
      itemType: "itemType",
      label: "label",
      name: "name",
      validationRules: "validationRules",
      visibleIndex: "visibleIndex",
      alignItemLabels: "alignItemLabels",
      caption: "caption",
      captionTemplate: "captionTemplate",
      colCount: "colCount",
      colCountByScreen: "colCountByScreen",
      items: "items",
      tabPanelOptions: "tabPanelOptions",
      tabs: "tabs",
      buttonOptions: "buttonOptions",
      horizontalAlignment: "horizontalAlignment",
      verticalAlignment: "verticalAlignment"
    },
    standalone: false,
    features: [i0.ɵɵProvidersFeature([NestedOptionHost, DxTemplateHost]), i0.ɵɵInheritDefinitionFeature],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function DxiFormItemComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    styles: ["[_nghost-%COMP%]{display:block}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DxiFormItemComponent, [{
    type: Component,
    args: [{
      selector: 'dxi-form-item',
      template: '<ng-content></ng-content>',
      providers: [NestedOptionHost, DxTemplateHost],
      styles: [":host{display:block}\n"]
    }]
  }], () => [{
    type: i1.NestedOptionHost,
    decorators: [{
      type: SkipSelf
    }, {
      type: Host
    }]
  }, {
    type: i1.NestedOptionHost,
    decorators: [{
      type: Host
    }]
  }, {
    type: i0.Renderer2
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [DOCUMENT]
    }]
  }, {
    type: i1.DxTemplateHost,
    decorators: [{
      type: Host
    }]
  }, {
    type: i0.ElementRef
  }], {
    badge: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    html: [{
      type: Input
    }],
    icon: [{
      type: Input
    }],
    tabTemplate: [{
      type: Input
    }],
    template: [{
      type: Input
    }],
    text: [{
      type: Input
    }],
    title: [{
      type: Input
    }],
    visible: [{
      type: Input
    }],
    colSpan: [{
      type: Input
    }],
    cssClass: [{
      type: Input
    }],
    dataField: [{
      type: Input
    }],
    editorOptions: [{
      type: Input
    }],
    editorType: [{
      type: Input
    }],
    helpText: [{
      type: Input
    }],
    isRequired: [{
      type: Input
    }],
    itemType: [{
      type: Input
    }],
    label: [{
      type: Input
    }],
    name: [{
      type: Input
    }],
    validationRules: [{
      type: Input
    }],
    visibleIndex: [{
      type: Input
    }],
    alignItemLabels: [{
      type: Input
    }],
    caption: [{
      type: Input
    }],
    captionTemplate: [{
      type: Input
    }],
    colCount: [{
      type: Input
    }],
    colCountByScreen: [{
      type: Input
    }],
    items: [{
      type: Input
    }],
    tabPanelOptions: [{
      type: Input
    }],
    tabs: [{
      type: Input
    }],
    buttonOptions: [{
      type: Input
    }],
    horizontalAlignment: [{
      type: Input
    }],
    verticalAlignment: [{
      type: Input
    }],
    asyncRulesChildren: [{
      type: ContentChildren,
      args: [forwardRef(() => DxiFormAsyncRuleComponent)]
    }],
    compareRulesChildren: [{
      type: ContentChildren,
      args: [forwardRef(() => DxiFormCompareRuleComponent)]
    }],
    customRulesChildren: [{
      type: ContentChildren,
      args: [forwardRef(() => DxiFormCustomRuleComponent)]
    }],
    emailRulesChildren: [{
      type: ContentChildren,
      args: [forwardRef(() => DxiFormEmailRuleComponent)]
    }],
    numericRulesChildren: [{
      type: ContentChildren,
      args: [forwardRef(() => DxiFormNumericRuleComponent)]
    }],
    patternRulesChildren: [{
      type: ContentChildren,
      args: [forwardRef(() => DxiFormPatternRuleComponent)]
    }],
    rangeRulesChildren: [{
      type: ContentChildren,
      args: [forwardRef(() => DxiFormRangeRuleComponent)]
    }],
    requiredRulesChildren: [{
      type: ContentChildren,
      args: [forwardRef(() => DxiFormRequiredRuleComponent)]
    }],
    stringLengthRulesChildren: [{
      type: ContentChildren,
      args: [forwardRef(() => DxiFormStringLengthRuleComponent)]
    }],
    tabsChildren: [{
      type: ContentChildren,
      args: [forwardRef(() => DxiFormTabComponent)]
    }],
    validationRulesChildren: [{
      type: ContentChildren,
      args: [forwardRef(() => DxiFormValidationRuleComponent)]
    }]
  });
})();
class DxiFormItemModule {
  /** @nocollapse */static ɵfac = function DxiFormItemModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DxiFormItemModule)();
  };
  /** @nocollapse */
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: DxiFormItemModule
  });
  /** @nocollapse */
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DxiFormItemModule, [{
    type: NgModule,
    args: [{
      declarations: [DxiFormItemComponent],
      exports: [DxiFormItemComponent]
    }]
  }], null, null);
})();

/*!
 * devextreme-angular
 * Version: 24.2.3
 * Build date: Fri Dec 06 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
class DxoFormLabelComponent extends NestedOption {
  renderer;
  document;
  element;
  get alignment() {
    return this._getOption('alignment');
  }
  set alignment(value) {
    this._setOption('alignment', value);
  }
  get location() {
    return this._getOption('location');
  }
  set location(value) {
    this._setOption('location', value);
  }
  get showColon() {
    return this._getOption('showColon');
  }
  set showColon(value) {
    this._setOption('showColon', value);
  }
  get template() {
    return this._getOption('template');
  }
  set template(value) {
    this._setOption('template', value);
  }
  get text() {
    return this._getOption('text');
  }
  set text(value) {
    this._setOption('text', value);
  }
  get visible() {
    return this._getOption('visible');
  }
  set visible(value) {
    this._setOption('visible', value);
  }
  get _optionPath() {
    return 'label';
  }
  constructor(parentOptionHost, optionHost, renderer, document, templateHost, element) {
    super();
    this.renderer = renderer;
    this.document = document;
    this.element = element;
    parentOptionHost.setNestedOption(this);
    optionHost.setHost(this, this._fullOptionPath.bind(this));
    templateHost.setHost(this);
  }
  setTemplate(template) {
    this.template = template;
  }
  ngAfterViewInit() {
    extractTemplate(this, this.element, this.renderer, this.document);
  }
  ngOnInit() {
    this._addRecreatedComponent();
  }
  ngOnDestroy() {
    this._addRemovedOption(this._getOptionPath());
  }
  /** @nocollapse */
  static ɵfac = function DxoFormLabelComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DxoFormLabelComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i1.DxTemplateHost, 1), i0.ɵɵdirectiveInject(i0.ElementRef));
  };
  /** @nocollapse */
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DxoFormLabelComponent,
    selectors: [["dxo-form-label"]],
    inputs: {
      alignment: "alignment",
      location: "location",
      showColon: "showColon",
      template: "template",
      text: "text",
      visible: "visible"
    },
    standalone: false,
    features: [i0.ɵɵProvidersFeature([NestedOptionHost, DxTemplateHost]), i0.ɵɵInheritDefinitionFeature],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function DxoFormLabelComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    styles: ["[_nghost-%COMP%]{display:block}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DxoFormLabelComponent, [{
    type: Component,
    args: [{
      selector: 'dxo-form-label',
      template: '<ng-content></ng-content>',
      providers: [NestedOptionHost, DxTemplateHost],
      styles: [":host{display:block}\n"]
    }]
  }], () => [{
    type: i1.NestedOptionHost,
    decorators: [{
      type: SkipSelf
    }, {
      type: Host
    }]
  }, {
    type: i1.NestedOptionHost,
    decorators: [{
      type: Host
    }]
  }, {
    type: i0.Renderer2
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [DOCUMENT]
    }]
  }, {
    type: i1.DxTemplateHost,
    decorators: [{
      type: Host
    }]
  }, {
    type: i0.ElementRef
  }], {
    alignment: [{
      type: Input
    }],
    location: [{
      type: Input
    }],
    showColon: [{
      type: Input
    }],
    template: [{
      type: Input
    }],
    text: [{
      type: Input
    }],
    visible: [{
      type: Input
    }]
  });
})();
class DxoFormLabelModule {
  /** @nocollapse */static ɵfac = function DxoFormLabelModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DxoFormLabelModule)();
  };
  /** @nocollapse */
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: DxoFormLabelModule
  });
  /** @nocollapse */
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DxoFormLabelModule, [{
    type: NgModule,
    args: [{
      declarations: [DxoFormLabelComponent],
      exports: [DxoFormLabelComponent]
    }]
  }], null, null);
})();

/*!
 * devextreme-angular
 * Version: 24.2.3
 * Build date: Fri Dec 06 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
class DxiFormSimpleItemComponent extends CollectionNestedOption {
  renderer;
  document;
  element;
  get colSpan() {
    return this._getOption('colSpan');
  }
  set colSpan(value) {
    this._setOption('colSpan', value);
  }
  get cssClass() {
    return this._getOption('cssClass');
  }
  set cssClass(value) {
    this._setOption('cssClass', value);
  }
  get dataField() {
    return this._getOption('dataField');
  }
  set dataField(value) {
    this._setOption('dataField', value);
  }
  get editorOptions() {
    return this._getOption('editorOptions');
  }
  set editorOptions(value) {
    this._setOption('editorOptions', value);
  }
  get editorType() {
    return this._getOption('editorType');
  }
  set editorType(value) {
    this._setOption('editorType', value);
  }
  get helpText() {
    return this._getOption('helpText');
  }
  set helpText(value) {
    this._setOption('helpText', value);
  }
  get isRequired() {
    return this._getOption('isRequired');
  }
  set isRequired(value) {
    this._setOption('isRequired', value);
  }
  get itemType() {
    return this._getOption('itemType');
  }
  set itemType(value) {
    this._setOption('itemType', value);
  }
  get label() {
    return this._getOption('label');
  }
  set label(value) {
    this._setOption('label', value);
  }
  get name() {
    return this._getOption('name');
  }
  set name(value) {
    this._setOption('name', value);
  }
  get template() {
    return this._getOption('template');
  }
  set template(value) {
    this._setOption('template', value);
  }
  get validationRules() {
    return this._getOption('validationRules');
  }
  set validationRules(value) {
    this._setOption('validationRules', value);
  }
  get visible() {
    return this._getOption('visible');
  }
  set visible(value) {
    this._setOption('visible', value);
  }
  get visibleIndex() {
    return this._getOption('visibleIndex');
  }
  set visibleIndex(value) {
    this._setOption('visibleIndex', value);
  }
  get _optionPath() {
    return 'items';
  }
  get asyncRulesChildren() {
    return this._getOption('validationRules');
  }
  set asyncRulesChildren(value) {
    this.setChildren('validationRules', value);
  }
  get compareRulesChildren() {
    return this._getOption('validationRules');
  }
  set compareRulesChildren(value) {
    this.setChildren('validationRules', value);
  }
  get customRulesChildren() {
    return this._getOption('validationRules');
  }
  set customRulesChildren(value) {
    this.setChildren('validationRules', value);
  }
  get emailRulesChildren() {
    return this._getOption('validationRules');
  }
  set emailRulesChildren(value) {
    this.setChildren('validationRules', value);
  }
  get numericRulesChildren() {
    return this._getOption('validationRules');
  }
  set numericRulesChildren(value) {
    this.setChildren('validationRules', value);
  }
  get patternRulesChildren() {
    return this._getOption('validationRules');
  }
  set patternRulesChildren(value) {
    this.setChildren('validationRules', value);
  }
  get rangeRulesChildren() {
    return this._getOption('validationRules');
  }
  set rangeRulesChildren(value) {
    this.setChildren('validationRules', value);
  }
  get requiredRulesChildren() {
    return this._getOption('validationRules');
  }
  set requiredRulesChildren(value) {
    this.setChildren('validationRules', value);
  }
  get stringLengthRulesChildren() {
    return this._getOption('validationRules');
  }
  set stringLengthRulesChildren(value) {
    this.setChildren('validationRules', value);
  }
  get validationRulesChildren() {
    return this._getOption('validationRules');
  }
  set validationRulesChildren(value) {
    this.setChildren('validationRules', value);
  }
  constructor(parentOptionHost, optionHost, renderer, document, templateHost, element) {
    super();
    this.renderer = renderer;
    this.document = document;
    this.element = element;
    parentOptionHost.setNestedOption(this);
    optionHost.setHost(this, this._fullOptionPath.bind(this));
    templateHost.setHost(this);
  }
  setTemplate(template) {
    this.template = template;
  }
  ngAfterViewInit() {
    extractTemplate(this, this.element, this.renderer, this.document);
  }
  ngOnDestroy() {
    this._deleteRemovedOptions(this._fullOptionPath());
  }
  /** @nocollapse */
  static ɵfac = function DxiFormSimpleItemComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DxiFormSimpleItemComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i1.DxTemplateHost, 1), i0.ɵɵdirectiveInject(i0.ElementRef));
  };
  /** @nocollapse */
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DxiFormSimpleItemComponent,
    selectors: [["dxi-form-simple-item"]],
    contentQueries: function DxiFormSimpleItemComponent_ContentQueries(rf, ctx, dirIndex) {
      if (rf & 1) {
        i0.ɵɵcontentQuery(dirIndex, DxiFormAsyncRuleComponent, 4);
        i0.ɵɵcontentQuery(dirIndex, DxiFormCompareRuleComponent, 4);
        i0.ɵɵcontentQuery(dirIndex, DxiFormCustomRuleComponent, 4);
        i0.ɵɵcontentQuery(dirIndex, DxiFormEmailRuleComponent, 4);
        i0.ɵɵcontentQuery(dirIndex, DxiFormNumericRuleComponent, 4);
        i0.ɵɵcontentQuery(dirIndex, DxiFormPatternRuleComponent, 4);
        i0.ɵɵcontentQuery(dirIndex, DxiFormRangeRuleComponent, 4);
        i0.ɵɵcontentQuery(dirIndex, DxiFormRequiredRuleComponent, 4);
        i0.ɵɵcontentQuery(dirIndex, DxiFormStringLengthRuleComponent, 4);
        i0.ɵɵcontentQuery(dirIndex, DxiFormValidationRuleComponent, 4);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.asyncRulesChildren = _t);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.compareRulesChildren = _t);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.customRulesChildren = _t);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.emailRulesChildren = _t);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.numericRulesChildren = _t);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.patternRulesChildren = _t);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rangeRulesChildren = _t);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.requiredRulesChildren = _t);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.stringLengthRulesChildren = _t);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.validationRulesChildren = _t);
      }
    },
    inputs: {
      colSpan: "colSpan",
      cssClass: "cssClass",
      dataField: "dataField",
      editorOptions: "editorOptions",
      editorType: "editorType",
      helpText: "helpText",
      isRequired: "isRequired",
      itemType: "itemType",
      label: "label",
      name: "name",
      template: "template",
      validationRules: "validationRules",
      visible: "visible",
      visibleIndex: "visibleIndex"
    },
    standalone: false,
    features: [i0.ɵɵProvidersFeature([NestedOptionHost, DxTemplateHost]), i0.ɵɵInheritDefinitionFeature],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function DxiFormSimpleItemComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    styles: ["[_nghost-%COMP%]{display:block}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DxiFormSimpleItemComponent, [{
    type: Component,
    args: [{
      selector: 'dxi-form-simple-item',
      template: '<ng-content></ng-content>',
      providers: [NestedOptionHost, DxTemplateHost],
      styles: [":host{display:block}\n"]
    }]
  }], () => [{
    type: i1.NestedOptionHost,
    decorators: [{
      type: SkipSelf
    }, {
      type: Host
    }]
  }, {
    type: i1.NestedOptionHost,
    decorators: [{
      type: Host
    }]
  }, {
    type: i0.Renderer2
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [DOCUMENT]
    }]
  }, {
    type: i1.DxTemplateHost,
    decorators: [{
      type: Host
    }]
  }, {
    type: i0.ElementRef
  }], {
    colSpan: [{
      type: Input
    }],
    cssClass: [{
      type: Input
    }],
    dataField: [{
      type: Input
    }],
    editorOptions: [{
      type: Input
    }],
    editorType: [{
      type: Input
    }],
    helpText: [{
      type: Input
    }],
    isRequired: [{
      type: Input
    }],
    itemType: [{
      type: Input
    }],
    label: [{
      type: Input
    }],
    name: [{
      type: Input
    }],
    template: [{
      type: Input
    }],
    validationRules: [{
      type: Input
    }],
    visible: [{
      type: Input
    }],
    visibleIndex: [{
      type: Input
    }],
    asyncRulesChildren: [{
      type: ContentChildren,
      args: [forwardRef(() => DxiFormAsyncRuleComponent)]
    }],
    compareRulesChildren: [{
      type: ContentChildren,
      args: [forwardRef(() => DxiFormCompareRuleComponent)]
    }],
    customRulesChildren: [{
      type: ContentChildren,
      args: [forwardRef(() => DxiFormCustomRuleComponent)]
    }],
    emailRulesChildren: [{
      type: ContentChildren,
      args: [forwardRef(() => DxiFormEmailRuleComponent)]
    }],
    numericRulesChildren: [{
      type: ContentChildren,
      args: [forwardRef(() => DxiFormNumericRuleComponent)]
    }],
    patternRulesChildren: [{
      type: ContentChildren,
      args: [forwardRef(() => DxiFormPatternRuleComponent)]
    }],
    rangeRulesChildren: [{
      type: ContentChildren,
      args: [forwardRef(() => DxiFormRangeRuleComponent)]
    }],
    requiredRulesChildren: [{
      type: ContentChildren,
      args: [forwardRef(() => DxiFormRequiredRuleComponent)]
    }],
    stringLengthRulesChildren: [{
      type: ContentChildren,
      args: [forwardRef(() => DxiFormStringLengthRuleComponent)]
    }],
    validationRulesChildren: [{
      type: ContentChildren,
      args: [forwardRef(() => DxiFormValidationRuleComponent)]
    }]
  });
})();
class DxiFormSimpleItemModule {
  /** @nocollapse */static ɵfac = function DxiFormSimpleItemModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DxiFormSimpleItemModule)();
  };
  /** @nocollapse */
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: DxiFormSimpleItemModule
  });
  /** @nocollapse */
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DxiFormSimpleItemModule, [{
    type: NgModule,
    args: [{
      declarations: [DxiFormSimpleItemComponent],
      exports: [DxiFormSimpleItemComponent]
    }]
  }], null, null);
})();

/*!
 * devextreme-angular
 * Version: 24.2.3
 * Build date: Fri Dec 06 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
class DxiFormTabPanelOptionsItemComponent extends CollectionNestedOption {
  renderer;
  document;
  element;
  get badge() {
    return this._getOption('badge');
  }
  set badge(value) {
    this._setOption('badge', value);
  }
  get disabled() {
    return this._getOption('disabled');
  }
  set disabled(value) {
    this._setOption('disabled', value);
  }
  get html() {
    return this._getOption('html');
  }
  set html(value) {
    this._setOption('html', value);
  }
  get icon() {
    return this._getOption('icon');
  }
  set icon(value) {
    this._setOption('icon', value);
  }
  get tabTemplate() {
    return this._getOption('tabTemplate');
  }
  set tabTemplate(value) {
    this._setOption('tabTemplate', value);
  }
  get template() {
    return this._getOption('template');
  }
  set template(value) {
    this._setOption('template', value);
  }
  get text() {
    return this._getOption('text');
  }
  set text(value) {
    this._setOption('text', value);
  }
  get title() {
    return this._getOption('title');
  }
  set title(value) {
    this._setOption('title', value);
  }
  get visible() {
    return this._getOption('visible');
  }
  set visible(value) {
    this._setOption('visible', value);
  }
  get _optionPath() {
    return 'items';
  }
  constructor(parentOptionHost, optionHost, renderer, document, templateHost, element) {
    super();
    this.renderer = renderer;
    this.document = document;
    this.element = element;
    parentOptionHost.setNestedOption(this);
    optionHost.setHost(this, this._fullOptionPath.bind(this));
    templateHost.setHost(this);
  }
  setTemplate(template) {
    this.template = template;
  }
  ngAfterViewInit() {
    extractTemplate(this, this.element, this.renderer, this.document);
  }
  ngOnDestroy() {
    this._deleteRemovedOptions(this._fullOptionPath());
  }
  /** @nocollapse */
  static ɵfac = function DxiFormTabPanelOptionsItemComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DxiFormTabPanelOptionsItemComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i1.DxTemplateHost, 1), i0.ɵɵdirectiveInject(i0.ElementRef));
  };
  /** @nocollapse */
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DxiFormTabPanelOptionsItemComponent,
    selectors: [["dxi-form-tab-panel-options-item"]],
    inputs: {
      badge: "badge",
      disabled: "disabled",
      html: "html",
      icon: "icon",
      tabTemplate: "tabTemplate",
      template: "template",
      text: "text",
      title: "title",
      visible: "visible"
    },
    standalone: false,
    features: [i0.ɵɵProvidersFeature([NestedOptionHost, DxTemplateHost]), i0.ɵɵInheritDefinitionFeature],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function DxiFormTabPanelOptionsItemComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    styles: ["[_nghost-%COMP%]{display:block}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DxiFormTabPanelOptionsItemComponent, [{
    type: Component,
    args: [{
      selector: 'dxi-form-tab-panel-options-item',
      template: '<ng-content></ng-content>',
      providers: [NestedOptionHost, DxTemplateHost],
      styles: [":host{display:block}\n"]
    }]
  }], () => [{
    type: i1.NestedOptionHost,
    decorators: [{
      type: SkipSelf
    }, {
      type: Host
    }]
  }, {
    type: i1.NestedOptionHost,
    decorators: [{
      type: Host
    }]
  }, {
    type: i0.Renderer2
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [DOCUMENT]
    }]
  }, {
    type: i1.DxTemplateHost,
    decorators: [{
      type: Host
    }]
  }, {
    type: i0.ElementRef
  }], {
    badge: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    html: [{
      type: Input
    }],
    icon: [{
      type: Input
    }],
    tabTemplate: [{
      type: Input
    }],
    template: [{
      type: Input
    }],
    text: [{
      type: Input
    }],
    title: [{
      type: Input
    }],
    visible: [{
      type: Input
    }]
  });
})();
class DxiFormTabPanelOptionsItemModule {
  /** @nocollapse */static ɵfac = function DxiFormTabPanelOptionsItemModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DxiFormTabPanelOptionsItemModule)();
  };
  /** @nocollapse */
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: DxiFormTabPanelOptionsItemModule
  });
  /** @nocollapse */
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DxiFormTabPanelOptionsItemModule, [{
    type: NgModule,
    args: [{
      declarations: [DxiFormTabPanelOptionsItemComponent],
      exports: [DxiFormTabPanelOptionsItemComponent]
    }]
  }], null, null);
})();

/*!
 * devextreme-angular
 * Version: 24.2.3
 * Build date: Fri Dec 06 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
class DxoFormTabPanelOptionsComponent extends NestedOption {
  get accessKey() {
    return this._getOption('accessKey');
  }
  set accessKey(value) {
    this._setOption('accessKey', value);
  }
  get activeStateEnabled() {
    return this._getOption('activeStateEnabled');
  }
  set activeStateEnabled(value) {
    this._setOption('activeStateEnabled', value);
  }
  get animationEnabled() {
    return this._getOption('animationEnabled');
  }
  set animationEnabled(value) {
    this._setOption('animationEnabled', value);
  }
  get dataSource() {
    return this._getOption('dataSource');
  }
  set dataSource(value) {
    this._setOption('dataSource', value);
  }
  get deferRendering() {
    return this._getOption('deferRendering');
  }
  set deferRendering(value) {
    this._setOption('deferRendering', value);
  }
  get disabled() {
    return this._getOption('disabled');
  }
  set disabled(value) {
    this._setOption('disabled', value);
  }
  get elementAttr() {
    return this._getOption('elementAttr');
  }
  set elementAttr(value) {
    this._setOption('elementAttr', value);
  }
  get focusStateEnabled() {
    return this._getOption('focusStateEnabled');
  }
  set focusStateEnabled(value) {
    this._setOption('focusStateEnabled', value);
  }
  get height() {
    return this._getOption('height');
  }
  set height(value) {
    this._setOption('height', value);
  }
  get hint() {
    return this._getOption('hint');
  }
  set hint(value) {
    this._setOption('hint', value);
  }
  get hoverStateEnabled() {
    return this._getOption('hoverStateEnabled');
  }
  set hoverStateEnabled(value) {
    this._setOption('hoverStateEnabled', value);
  }
  get iconPosition() {
    return this._getOption('iconPosition');
  }
  set iconPosition(value) {
    this._setOption('iconPosition', value);
  }
  get itemHoldTimeout() {
    return this._getOption('itemHoldTimeout');
  }
  set itemHoldTimeout(value) {
    this._setOption('itemHoldTimeout', value);
  }
  get items() {
    return this._getOption('items');
  }
  set items(value) {
    this._setOption('items', value);
  }
  get itemTemplate() {
    return this._getOption('itemTemplate');
  }
  set itemTemplate(value) {
    this._setOption('itemTemplate', value);
  }
  get itemTitleTemplate() {
    return this._getOption('itemTitleTemplate');
  }
  set itemTitleTemplate(value) {
    this._setOption('itemTitleTemplate', value);
  }
  get loop() {
    return this._getOption('loop');
  }
  set loop(value) {
    this._setOption('loop', value);
  }
  get noDataText() {
    return this._getOption('noDataText');
  }
  set noDataText(value) {
    this._setOption('noDataText', value);
  }
  get onContentReady() {
    return this._getOption('onContentReady');
  }
  set onContentReady(value) {
    this._setOption('onContentReady', value);
  }
  get onDisposing() {
    return this._getOption('onDisposing');
  }
  set onDisposing(value) {
    this._setOption('onDisposing', value);
  }
  get onInitialized() {
    return this._getOption('onInitialized');
  }
  set onInitialized(value) {
    this._setOption('onInitialized', value);
  }
  get onItemClick() {
    return this._getOption('onItemClick');
  }
  set onItemClick(value) {
    this._setOption('onItemClick', value);
  }
  get onItemContextMenu() {
    return this._getOption('onItemContextMenu');
  }
  set onItemContextMenu(value) {
    this._setOption('onItemContextMenu', value);
  }
  get onItemHold() {
    return this._getOption('onItemHold');
  }
  set onItemHold(value) {
    this._setOption('onItemHold', value);
  }
  get onItemRendered() {
    return this._getOption('onItemRendered');
  }
  set onItemRendered(value) {
    this._setOption('onItemRendered', value);
  }
  get onOptionChanged() {
    return this._getOption('onOptionChanged');
  }
  set onOptionChanged(value) {
    this._setOption('onOptionChanged', value);
  }
  get onSelectionChanged() {
    return this._getOption('onSelectionChanged');
  }
  set onSelectionChanged(value) {
    this._setOption('onSelectionChanged', value);
  }
  get onSelectionChanging() {
    return this._getOption('onSelectionChanging');
  }
  set onSelectionChanging(value) {
    this._setOption('onSelectionChanging', value);
  }
  get onTitleClick() {
    return this._getOption('onTitleClick');
  }
  set onTitleClick(value) {
    this._setOption('onTitleClick', value);
  }
  get onTitleHold() {
    return this._getOption('onTitleHold');
  }
  set onTitleHold(value) {
    this._setOption('onTitleHold', value);
  }
  get onTitleRendered() {
    return this._getOption('onTitleRendered');
  }
  set onTitleRendered(value) {
    this._setOption('onTitleRendered', value);
  }
  get repaintChangesOnly() {
    return this._getOption('repaintChangesOnly');
  }
  set repaintChangesOnly(value) {
    this._setOption('repaintChangesOnly', value);
  }
  get rtlEnabled() {
    return this._getOption('rtlEnabled');
  }
  set rtlEnabled(value) {
    this._setOption('rtlEnabled', value);
  }
  get scrollByContent() {
    return this._getOption('scrollByContent');
  }
  set scrollByContent(value) {
    this._setOption('scrollByContent', value);
  }
  get scrollingEnabled() {
    return this._getOption('scrollingEnabled');
  }
  set scrollingEnabled(value) {
    this._setOption('scrollingEnabled', value);
  }
  get selectedIndex() {
    return this._getOption('selectedIndex');
  }
  set selectedIndex(value) {
    this._setOption('selectedIndex', value);
  }
  get selectedItem() {
    return this._getOption('selectedItem');
  }
  set selectedItem(value) {
    this._setOption('selectedItem', value);
  }
  get showNavButtons() {
    return this._getOption('showNavButtons');
  }
  set showNavButtons(value) {
    this._setOption('showNavButtons', value);
  }
  get stylingMode() {
    return this._getOption('stylingMode');
  }
  set stylingMode(value) {
    this._setOption('stylingMode', value);
  }
  get swipeEnabled() {
    return this._getOption('swipeEnabled');
  }
  set swipeEnabled(value) {
    this._setOption('swipeEnabled', value);
  }
  get tabIndex() {
    return this._getOption('tabIndex');
  }
  set tabIndex(value) {
    this._setOption('tabIndex', value);
  }
  get tabsPosition() {
    return this._getOption('tabsPosition');
  }
  set tabsPosition(value) {
    this._setOption('tabsPosition', value);
  }
  get visible() {
    return this._getOption('visible');
  }
  set visible(value) {
    this._setOption('visible', value);
  }
  get width() {
    return this._getOption('width');
  }
  set width(value) {
    this._setOption('width', value);
  }
  /**
  
   * This member supports the internal infrastructure and is not intended to be used directly from your code.
  
   */
  itemsChange;
  /**
  
   * This member supports the internal infrastructure and is not intended to be used directly from your code.
  
   */
  selectedIndexChange;
  /**
  
   * This member supports the internal infrastructure and is not intended to be used directly from your code.
  
   */
  selectedItemChange;
  get _optionPath() {
    return 'tabPanelOptions';
  }
  get itemsChildren() {
    return this._getOption('items');
  }
  set itemsChildren(value) {
    this.setChildren('items', value);
  }
  get tabPanelOptionsItemsChildren() {
    return this._getOption('items');
  }
  set tabPanelOptionsItemsChildren(value) {
    this.setChildren('items', value);
  }
  constructor(parentOptionHost, optionHost) {
    super();
    this._createEventEmitters([{
      emit: 'itemsChange'
    }, {
      emit: 'selectedIndexChange'
    }, {
      emit: 'selectedItemChange'
    }]);
    parentOptionHost.setNestedOption(this);
    optionHost.setHost(this, this._fullOptionPath.bind(this));
  }
  ngOnInit() {
    this._addRecreatedComponent();
  }
  ngOnDestroy() {
    this._addRemovedOption(this._getOptionPath());
  }
  /** @nocollapse */
  static ɵfac = function DxoFormTabPanelOptionsComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DxoFormTabPanelOptionsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
  };
  /** @nocollapse */
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DxoFormTabPanelOptionsComponent,
    selectors: [["dxo-form-tab-panel-options"]],
    contentQueries: function DxoFormTabPanelOptionsComponent_ContentQueries(rf, ctx, dirIndex) {
      if (rf & 1) {
        i0.ɵɵcontentQuery(dirIndex, DxiFormItemComponent, 4);
        i0.ɵɵcontentQuery(dirIndex, DxiFormTabPanelOptionsItemComponent, 4);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.itemsChildren = _t);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tabPanelOptionsItemsChildren = _t);
      }
    },
    inputs: {
      accessKey: "accessKey",
      activeStateEnabled: "activeStateEnabled",
      animationEnabled: "animationEnabled",
      dataSource: "dataSource",
      deferRendering: "deferRendering",
      disabled: "disabled",
      elementAttr: "elementAttr",
      focusStateEnabled: "focusStateEnabled",
      height: "height",
      hint: "hint",
      hoverStateEnabled: "hoverStateEnabled",
      iconPosition: "iconPosition",
      itemHoldTimeout: "itemHoldTimeout",
      items: "items",
      itemTemplate: "itemTemplate",
      itemTitleTemplate: "itemTitleTemplate",
      loop: "loop",
      noDataText: "noDataText",
      onContentReady: "onContentReady",
      onDisposing: "onDisposing",
      onInitialized: "onInitialized",
      onItemClick: "onItemClick",
      onItemContextMenu: "onItemContextMenu",
      onItemHold: "onItemHold",
      onItemRendered: "onItemRendered",
      onOptionChanged: "onOptionChanged",
      onSelectionChanged: "onSelectionChanged",
      onSelectionChanging: "onSelectionChanging",
      onTitleClick: "onTitleClick",
      onTitleHold: "onTitleHold",
      onTitleRendered: "onTitleRendered",
      repaintChangesOnly: "repaintChangesOnly",
      rtlEnabled: "rtlEnabled",
      scrollByContent: "scrollByContent",
      scrollingEnabled: "scrollingEnabled",
      selectedIndex: "selectedIndex",
      selectedItem: "selectedItem",
      showNavButtons: "showNavButtons",
      stylingMode: "stylingMode",
      swipeEnabled: "swipeEnabled",
      tabIndex: "tabIndex",
      tabsPosition: "tabsPosition",
      visible: "visible",
      width: "width"
    },
    outputs: {
      itemsChange: "itemsChange",
      selectedIndexChange: "selectedIndexChange",
      selectedItemChange: "selectedItemChange"
    },
    standalone: false,
    features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
    decls: 0,
    vars: 0,
    template: function DxoFormTabPanelOptionsComponent_Template(rf, ctx) {},
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DxoFormTabPanelOptionsComponent, [{
    type: Component,
    args: [{
      selector: 'dxo-form-tab-panel-options',
      template: '',
      providers: [NestedOptionHost]
    }]
  }], () => [{
    type: i1.NestedOptionHost,
    decorators: [{
      type: SkipSelf
    }, {
      type: Host
    }]
  }, {
    type: i1.NestedOptionHost,
    decorators: [{
      type: Host
    }]
  }], {
    accessKey: [{
      type: Input
    }],
    activeStateEnabled: [{
      type: Input
    }],
    animationEnabled: [{
      type: Input
    }],
    dataSource: [{
      type: Input
    }],
    deferRendering: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    elementAttr: [{
      type: Input
    }],
    focusStateEnabled: [{
      type: Input
    }],
    height: [{
      type: Input
    }],
    hint: [{
      type: Input
    }],
    hoverStateEnabled: [{
      type: Input
    }],
    iconPosition: [{
      type: Input
    }],
    itemHoldTimeout: [{
      type: Input
    }],
    items: [{
      type: Input
    }],
    itemTemplate: [{
      type: Input
    }],
    itemTitleTemplate: [{
      type: Input
    }],
    loop: [{
      type: Input
    }],
    noDataText: [{
      type: Input
    }],
    onContentReady: [{
      type: Input
    }],
    onDisposing: [{
      type: Input
    }],
    onInitialized: [{
      type: Input
    }],
    onItemClick: [{
      type: Input
    }],
    onItemContextMenu: [{
      type: Input
    }],
    onItemHold: [{
      type: Input
    }],
    onItemRendered: [{
      type: Input
    }],
    onOptionChanged: [{
      type: Input
    }],
    onSelectionChanged: [{
      type: Input
    }],
    onSelectionChanging: [{
      type: Input
    }],
    onTitleClick: [{
      type: Input
    }],
    onTitleHold: [{
      type: Input
    }],
    onTitleRendered: [{
      type: Input
    }],
    repaintChangesOnly: [{
      type: Input
    }],
    rtlEnabled: [{
      type: Input
    }],
    scrollByContent: [{
      type: Input
    }],
    scrollingEnabled: [{
      type: Input
    }],
    selectedIndex: [{
      type: Input
    }],
    selectedItem: [{
      type: Input
    }],
    showNavButtons: [{
      type: Input
    }],
    stylingMode: [{
      type: Input
    }],
    swipeEnabled: [{
      type: Input
    }],
    tabIndex: [{
      type: Input
    }],
    tabsPosition: [{
      type: Input
    }],
    visible: [{
      type: Input
    }],
    width: [{
      type: Input
    }],
    itemsChange: [{
      type: Output
    }],
    selectedIndexChange: [{
      type: Output
    }],
    selectedItemChange: [{
      type: Output
    }],
    itemsChildren: [{
      type: ContentChildren,
      args: [forwardRef(() => DxiFormItemComponent)]
    }],
    tabPanelOptionsItemsChildren: [{
      type: ContentChildren,
      args: [forwardRef(() => DxiFormTabPanelOptionsItemComponent)]
    }]
  });
})();
class DxoFormTabPanelOptionsModule {
  /** @nocollapse */static ɵfac = function DxoFormTabPanelOptionsModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DxoFormTabPanelOptionsModule)();
  };
  /** @nocollapse */
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: DxoFormTabPanelOptionsModule
  });
  /** @nocollapse */
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DxoFormTabPanelOptionsModule, [{
    type: NgModule,
    args: [{
      declarations: [DxoFormTabPanelOptionsComponent],
      exports: [DxoFormTabPanelOptionsComponent]
    }]
  }], null, null);
})();

/*!
 * devextreme-angular
 * Version: 24.2.3
 * Build date: Fri Dec 06 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
class DxiFormTabbedItemComponent extends CollectionNestedOption {
  get colSpan() {
    return this._getOption('colSpan');
  }
  set colSpan(value) {
    this._setOption('colSpan', value);
  }
  get cssClass() {
    return this._getOption('cssClass');
  }
  set cssClass(value) {
    this._setOption('cssClass', value);
  }
  get itemType() {
    return this._getOption('itemType');
  }
  set itemType(value) {
    this._setOption('itemType', value);
  }
  get name() {
    return this._getOption('name');
  }
  set name(value) {
    this._setOption('name', value);
  }
  get tabPanelOptions() {
    return this._getOption('tabPanelOptions');
  }
  set tabPanelOptions(value) {
    this._setOption('tabPanelOptions', value);
  }
  get tabs() {
    return this._getOption('tabs');
  }
  set tabs(value) {
    this._setOption('tabs', value);
  }
  get visible() {
    return this._getOption('visible');
  }
  set visible(value) {
    this._setOption('visible', value);
  }
  get visibleIndex() {
    return this._getOption('visibleIndex');
  }
  set visibleIndex(value) {
    this._setOption('visibleIndex', value);
  }
  get _optionPath() {
    return 'items';
  }
  get tabsChildren() {
    return this._getOption('tabs');
  }
  set tabsChildren(value) {
    this.setChildren('tabs', value);
  }
  constructor(parentOptionHost, optionHost) {
    super();
    parentOptionHost.setNestedOption(this);
    optionHost.setHost(this, this._fullOptionPath.bind(this));
  }
  ngOnDestroy() {
    this._deleteRemovedOptions(this._fullOptionPath());
  }
  /** @nocollapse */
  static ɵfac = function DxiFormTabbedItemComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DxiFormTabbedItemComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
  };
  /** @nocollapse */
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DxiFormTabbedItemComponent,
    selectors: [["dxi-form-tabbed-item"]],
    contentQueries: function DxiFormTabbedItemComponent_ContentQueries(rf, ctx, dirIndex) {
      if (rf & 1) {
        i0.ɵɵcontentQuery(dirIndex, DxiFormTabComponent, 4);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tabsChildren = _t);
      }
    },
    inputs: {
      colSpan: "colSpan",
      cssClass: "cssClass",
      itemType: "itemType",
      name: "name",
      tabPanelOptions: "tabPanelOptions",
      tabs: "tabs",
      visible: "visible",
      visibleIndex: "visibleIndex"
    },
    standalone: false,
    features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
    decls: 0,
    vars: 0,
    template: function DxiFormTabbedItemComponent_Template(rf, ctx) {},
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DxiFormTabbedItemComponent, [{
    type: Component,
    args: [{
      selector: 'dxi-form-tabbed-item',
      template: '',
      providers: [NestedOptionHost]
    }]
  }], () => [{
    type: i1.NestedOptionHost,
    decorators: [{
      type: SkipSelf
    }, {
      type: Host
    }]
  }, {
    type: i1.NestedOptionHost,
    decorators: [{
      type: Host
    }]
  }], {
    colSpan: [{
      type: Input
    }],
    cssClass: [{
      type: Input
    }],
    itemType: [{
      type: Input
    }],
    name: [{
      type: Input
    }],
    tabPanelOptions: [{
      type: Input
    }],
    tabs: [{
      type: Input
    }],
    visible: [{
      type: Input
    }],
    visibleIndex: [{
      type: Input
    }],
    tabsChildren: [{
      type: ContentChildren,
      args: [forwardRef(() => DxiFormTabComponent)]
    }]
  });
})();
class DxiFormTabbedItemModule {
  /** @nocollapse */static ɵfac = function DxiFormTabbedItemModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DxiFormTabbedItemModule)();
  };
  /** @nocollapse */
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: DxiFormTabbedItemModule
  });
  /** @nocollapse */
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DxiFormTabbedItemModule, [{
    type: NgModule,
    args: [{
      declarations: [DxiFormTabbedItemComponent],
      exports: [DxiFormTabbedItemComponent]
    }]
  }], null, null);
})();

/*!
 * devextreme-angular
 * Version: 24.2.3
 * Build date: Fri Dec 06 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DxiFormAsyncRuleComponent, DxiFormAsyncRuleModule, DxiFormButtonItemComponent, DxiFormButtonItemModule, DxiFormCompareRuleComponent, DxiFormCompareRuleModule, DxiFormCustomRuleComponent, DxiFormCustomRuleModule, DxiFormEmailRuleComponent, DxiFormEmailRuleModule, DxiFormEmptyItemComponent, DxiFormEmptyItemModule, DxiFormGroupItemComponent, DxiFormGroupItemModule, DxiFormItemComponent, DxiFormItemModule, DxiFormNumericRuleComponent, DxiFormNumericRuleModule, DxiFormPatternRuleComponent, DxiFormPatternRuleModule, DxiFormRangeRuleComponent, DxiFormRangeRuleModule, DxiFormRequiredRuleComponent, DxiFormRequiredRuleModule, DxiFormSimpleItemComponent, DxiFormSimpleItemModule, DxiFormStringLengthRuleComponent, DxiFormStringLengthRuleModule, DxiFormTabComponent, DxiFormTabModule, DxiFormTabPanelOptionsItemComponent, DxiFormTabPanelOptionsItemModule, DxiFormTabbedItemComponent, DxiFormTabbedItemModule, DxiFormValidationRuleComponent, DxiFormValidationRuleModule, DxoFormButtonOptionsComponent, DxoFormButtonOptionsModule, DxoFormColCountByScreenComponent, DxoFormColCountByScreenModule, DxoFormLabelComponent, DxoFormLabelModule, DxoFormTabPanelOptionsComponent, DxoFormTabPanelOptionsModule };
